// import React, { useEffect } from 'react'
// // import TagManager from 'react-gtm-module'
// import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
// import Home from './components/Home';
// import CreditCardPage from './components/creditCard/CreditCardPage';
// import Navbar from './components/Navbar/Navbar';
// import FooterComponent from './components/FooterComponent';
// import ResearchPage from './components/research/ResearchPage';
// import AboutPage from './components/about/AboutPage';
// import ContactPage from './components/contact/ContactPage';
// // import InsurancePage from './components/insurance/InsurancePage';
// // import BankDetail from './components/creditCard/BankDetail';
// import AMEX from './components/BankDetails/AMEX'
// import HDFC from './components/BankDetails/HDFC';
// import Au from './components/BankDetails/Au';
// import AXIX from './components/BankDetails/AXIX';
// import ICICI from './components/BankDetails/ICICI';
// import IDFC from './components/BankDetails/IDFC';
// import Indulnd from './components/BankDetails/Indulnd';
// import SBI from './components/BankDetails/SBI';
// import HdfcLearnMore from './components/LearnMore/HdfcLearnMore';
// import BankOfBaroda from './components/BankDetails/BankOfBaroda';
// import Citi from './components/BankDetails/Citi';
// import Federal from './components/BankDetails/Federal';
// import Hsbc from './components/BankDetails/Hsbc';
// import Kotak from './components/BankDetails/Kotak';
// import American from './components/BankDetails/American';
// import Standard from './components/BankDetails/Standard';
// import YesBank from './components/BankDetails/YesBank';
// import CashBack from './components/topButtons/CashBack';
// import Fuel from './components/topButtons/Fuel';
// import LifeTimeFee from './components/topButtons/LifeTimeFee';
// import Premium from './components/topButtons/Premium';
// import Travel from './components/topButtons/Travel';
// import TermsAndConditions from './components/privacy/TermsAndConditions';
// import PrivacyPolicy from './components/privacy/PrivacyPolicy';
// import AuBankLit from './components/featuredCards/AuBankLit';
// import EasyDinerBank from './components/featuredCards/EasyDinerBank';
// import HdfcBankMillennia from './components/featuredCards/HdfcBankMillennia';
// import SbiSimplyClick from './components/featuredCards/SbiSimplyClick';
// import IdfcFirstClassic from './components/featuredCards/IdfcFirstClassic';
// import FlipcartAxixBank from './components/featuredCards/FlipcartAxixBank';
// import LearnMoreAllCards from './components/cardComponents/LearnMoreAllCards';
// import ToolOfSipLipPages from './components/ToolsOfAllBanks/ToolOfSipLipPages';
// import ToolsPages from './components/ToolsOfAllBanks/ToolsPages';
// import SWPCalculator from './components/ToolsOfAllBanks/SWPCalculator';
// import MutualFundCalculator from './components/ToolsOfAllBanks/MutualFundCalculator';
// import SSYCalculator from './components/ToolsOfAllBanks/SSYCalculator';
// import PPFCalculator from './components/ToolsOfAllBanks/PPFCalculator';
// import EPFCalculator from './components/ToolsOfAllBanks/EPFCalculator';
// import FDCalculator from './components/ToolsOfAllBanks/FDCalculator';
// import RDCalculator from './components/ToolsOfAllBanks/RDCalculator';
// import NPSCalculator from './components/ToolsOfAllBanks/NPSCalculator';
// import HRACalculator from './components/ToolsOfAllBanks/HRACalculator';
// import RetirementCalculator from './components/ToolsOfAllBanks/RetirementCalculator';
// import EMICalculator from './components/ToolsOfAllBanks/EMICalculator';
// import Layout from './Layout';
// import SimpleInterestCalculator from './components/ToolsOfAllBanks/SimpleInterestCalculator';
// import CompoundInterestCalculator from './components/ToolsOfAllBanks/CompoundInterestCalculator';
// import NSCCalculator from './components/ToolsOfAllBanks/NSCCalculator';
// import StepUpSIPCalculator from './components/ToolsOfAllBanks/StepUpSIPCalculator';
// import IncomeTaxCalculator from './components/ToolsOfAllBanks/IncomeTaxCalculator';
// import CarLoanEMICalculator from './components/ToolsOfAllBanks/CarLoanEMICalculator';
// import HomeLoanEMICalculator from './components/ToolsOfAllBanks/HomeLoanEMICalculator';
// import GratuityCalculator from './components/ToolsOfAllBanks/GratuityCalculator';
// import APYCalculator from './components/ToolsOfAllBanks/APYCalculator';
// import CAGRCalculator from './components/ToolsOfAllBanks/CAGRCalculator';
// import GSTCalculator from './components/ToolsOfAllBanks/GSTCalculator';
// import FlatReducingRateCalculator from './components/ToolsOfAllBanks/FlatReducingRateCalculator';
// import EquityMarginCalculator from './components/ToolsOfAllBanks/EquityMarginCalculator';
// import InflationCalculator from './components/ToolsOfAllBanks/InflationCalculator';
// import SalaryCalculator from './components/ToolsOfAllBanks/SalaryCalculator';
// import BrokerageCalculator from './components/ToolsOfAllBanks/BrokerageCalculator';
// import TDSCalculator from './components/ToolsOfAllBanks/TDSCalculator';
// import LumpsumCalculator from './components/ToolsOfAllBanks/LumpsumCalculator';
// import SiteMapUi from './components/sitemap/SiteMapUi';
// import LayoutGTM from './LayoutGTM';
// import LayoutScroll from './LayoutScroll';
// import Blogs from './components/blog/Blogs';
// import SinglepageBlog from './components/blog/SinglepageBlog';
// import LoanMainPage from './components/LoanPages/LoanMainPage';
// import SingleLoanPage from './components/LoanPages/SingleLoanPage';
// import DematMainPage from './components/demat/DematMainPage';
// import SingleDematPage from './components/demat/SingleDematPage';
// import InsuranceMainPage from './components/InsuranceNewUi/InsuranceMainPage';
// import SingleInsurancePage from './components/InsuranceNewUi/SingleInsurancePage';
// import { Helmet } from 'react-helmet';
// function App() {

//   // const usePageTracking = () => {
//   //   const location = useLocation();

//   //   useEffect(() => {
//   //     if (window.gtag) {
//   //       window.gtag('config', 'G-DCYD12PDV7', {
//   //         page_path: location.pathname,
//   //       });
//   //     }
//   //   }, [location]);
//   // };

//   //   usePageTracking();

// const location = useLocation()
//   useEffect(() => {

//     window.scrollTo(0, 0);
//   }, [location.pathname]);

//   return (
//     <>
//     <Helmet>
//     <meta name="robots" content="noindex, nofollow" />
//     </Helmet>
//       {/* <Box sx={{ background: '#000' }}> */}
//       <Navbar />
//       {/* <NavBar /> */}
//       <Layout>
//         <LayoutScroll>
//       <Routes>

//         <Route path='/' exact element={<Home />} />

//         <Route path='/insurance_page' element={<InsuranceMainPage />} />
// <Route path='/Insurance_page/:id' element={<SingleInsurancePage />} />

// <Route path='/demat' element={<DematMainPage />} />
// <Route path='/demat/:id' element={<SingleDematPage />} />

//         <Route path='/loan_page/:id' element={<SingleLoanPage />} />
//          <Route path='/loan_page' element={<LoanMainPage />} />

//         <Route path='/blog_page/:id' element={<SinglepageBlog />} />
//         <Route path='/blog_page' element={<Blogs />} />
//         {/* <Route path='/blog_page' element={<Navigate to="/blogpage" replace /> }/> */}

//         <Route path='/sitemap' element={<SiteMapUi />} />
//         <Route path='/financial-tools-calculators/tds-calculator' element={<TDSCalculator />} />
//         <Route path='/financial-tools-calculators/brokerage-calculator' element={<BrokerageCalculator />} />
//         <Route path='/financial-tools-calculators/salary-calculator' element={<SalaryCalculator />} />
//         <Route path='/financial-tools-calculators/inflation-calculator' element={<InflationCalculator />} />
//         <Route path='/financial-tools-calculators/equity-margin-calculator' element={<EquityMarginCalculator />} />
//         <Route path='/financial-tools-calculators/flat-vs-reducing-rate-calculator' element={<FlatReducingRateCalculator />} />
//         <Route path='/financial-tools-calculators/gst-calculator' element={<GSTCalculator />} />
//         <Route path='/financial-tools-calculators/cagr-calculator' element={<CAGRCalculator />} />
//         <Route path='/financial-tools-calculators/apy-calculator' element={<APYCalculator />} />
//         <Route path='/financial-tools-calculators/gratuity-calculator' element={<GratuityCalculator />} />
//         <Route path='/financial-tools-calculators/car-loan-emi-calculator' element={<CarLoanEMICalculator />} />
//         <Route path='/financial-tools-calculators/home-loan-emi-calculator' element={<HomeLoanEMICalculator />} />
//         <Route path='/financial-tools-calculators/income-tax-calculator' element={<IncomeTaxCalculator />} />
//         <Route path='/financial-tools-calculators/step-up-sip-calculator' element={<StepUpSIPCalculator />} />
//         <Route path='/financial-tools-calculators/nsc-calculator' element={<NSCCalculator />} />
//         <Route path='/financial-tools-calculators/compound-interest-calculator' element={<CompoundInterestCalculator />} />
// <Route path='/financial-tools-calculators/simple-interest-calculator' element={<SimpleInterestCalculator />} />
//         <Route path='/financial-tools-calculators/emi-calculator' element={<EMICalculator />} />
//         <Route path='/financial-tools-calculators/retirement-planning-calculator' element={<RetirementCalculator />} />
//         <Route path='/financial-tools-calculators/hra-exemption-calculator' element={<HRACalculator />} />
//         <Route path='/financial-tools-calculators/nps-calculator' element={<NPSCalculator />} />
//         <Route path='/financial-tools-calculators/rd-calculator' element={<RDCalculator />} />
//         <Route path='/financial-tools-calculators/fd-calculator' element={<FDCalculator />} />
//         <Route path='/financial-tools-calculators/pf-epf-calculator' element={<EPFCalculator />} />
//         <Route path='/financial-tools-calculators/ppf-calculator' element={<PPFCalculator />} />
//         <Route path='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator' element={<SSYCalculator />} />
//         <Route path='/financial-tools-calculators/mutual-fund-calculator' element={<MutualFundCalculator />} />
//         <Route path='/financial-tools-calculators/swp-calculator' element={<SWPCalculator />} />
//         <Route path='/financial-tools-calculators' element={<ToolsPages />} />
//         <Route path='/financial-tools-calculators/sip-calculator' element={<ToolOfSipLipPages />} />
//         <Route path='/financial-tools-calculators/lumpsum-calculator' element={<ToolOfSipLipPages />} />
//          <Route path='/learn-more-page/card' element={<LearnMoreAllCards />} />
//         <Route path='/credit-card/aubank-credit-card' element={<AuBankLit />} />
//         <Route path='/credit-card/eazy-diner-indusind-bank-credit-card' element={<EasyDinerBank />} />
//         <Route path='/credit-card/hdfc-bank/millennia-credit-card' element={<HdfcBankMillennia />} />
//         <Route path='/credit-card/sbi-simplyclick-credit-card' element={<SbiSimplyClick />} />
//         <Route path='/credit-card/idfcfirst-classic-credit-card' element={<IdfcFirstClassic />} />
//         <Route path='/credit-card/axis-bank-flipkart-credit-card' element={<FlipcartAxixBank />} />
//         <Route path='/privacy-policy' element={<PrivacyPolicy />} />
//         <Route path='/term-and-conditions' element={<TermsAndConditions />} />
//         <Route path='/amex_detail' element={<AMEX />} />
//         <Route path='/au-bank/credit-card' element={<Au />} />
//         <Route path='/axix-bank/credit-card' element={<AXIX />} />
//         <Route path='/icici-bank/credit-card' element={<ICICI />} />
//         <Route path='/idfc-bank/credit-card' element={<IDFC />} />
//         <Route path='/induslnd-bank/credit-card' element={<Indulnd />} />
//         <Route path='/sbi-bank/credit-card' element={<SBI />} />
//         <Route path='/hdfc-bank/credit-card' element={<HDFC />} />
//         <Route path='/bank-of-baroda/credit-card' element={<BankOfBaroda />} />
//         <Route path='/citi_detail' element={<Citi />} />
//         <Route path='/fedral_detail' element={<Federal />} />
//         <Route path='/hsbc-bank/credit-card' element={<Hsbc />} />
//         <Route path='/kotak_detail' element={<Kotak />} />
//         <Route path='/american-bank/credit-card' element={<American />} />
//         <Route path='/standard-bank/credit-card' element={<Standard />} />
//         <Route path='/yes-bank/credit-card' element={<YesBank />} />
//         <Route path='/hdfc_learn_more' element={<HdfcLearnMore />} />
//         <Route path='/credit-card/travel-credit-card' element={<Travel />} />
//         <Route path='/credit-card/best-cashback-credit-card' element={<CashBack />} />
//         <Route path='/credit-card/best-premium-credit-card' element={<Premium />} />
//         <Route path='/credit-card/best-lifetime-free-credit-cards' element={<LifeTimeFee />} />
//         <Route path='/credit-card/fuel-credit-card' element={<Fuel />} />
//         {/* <Route path='/detailofbank' element={<BankDetail />} /> */}
//         <Route path='/credit-card' element={<CreditCardPage />} />
//         {/* <Route path='/demat' element={<Demat />} /> */}
//         <Route path='/research' element={<ResearchPage />} />
//         <Route path='/about' element={<AboutPage />} />
//         <Route path='/contact-us' element={<ContactPage />} />
//         {/* <Route path='/insurance' element={<InsurancePage />} /> */}
//         {/* <Route path='/blog' element={<BlogPage />} /> */}
//         {/* <Route path='/blog_page/:id' element={<BlogPost />} /> */}
//         {/* <Route path='/video/:id' element={<VideoDetail />} />
//           <Route path='/channel/:id' element={<ChannelDetail />} />
//           <Route path='/search/:searchTerm' element={<SearchFeed />} /> */}
//       </Routes>
//       <LayoutGTM>
//       <FooterComponent />
//       </LayoutGTM>
//       </LayoutScroll>
//       </Layout>

//        {/* </Box> */ }
//     </>

//   );
// }

// export default App;

import React, { useEffect } from "react";

// import TagManager from 'react-gtm-module'
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/Home";
import PersonalLoan from "./components/personalLoan/PersonalLoan";
import CreditCardPage from "./components/creditCard/CreditCardPage";
// import NavBar from './components/NavBar';
// import Navbar from './components/Navbar/Navbar';
import FooterComponent from "./components/FooterComponent";
// import BlogPage from './components/blog/BlogPage';
import ResearchPage from "./components/research/ResearchPage";
import AboutPage from "./components/about/AboutPage";
import ContactPage from "./components/contact/ContactPage";
// import InsurancePage from './components/insurance/InsurancePage';
import LifeInsurance from "./components/insurance/LifeInsurance";
import HealthInsurance from "./components/insurance/HealthInsurance";
import CarInsurance from "./components/insurance/CarInsurance";
import BikeInsurance from "./components/insurance/BikeInsurance";
import TermInsurance from "./components/insurance/TermInsurance";
import TravelInsurance from "./components/insurance/TravelInsurance";
// import BlogPost from './components/blog/BlogPost';
// import BankDetail from './components/creditCard/BankDetail';
import AMEX from "./components/BankDetails/AMEX";
import HDFC from "./components/BankDetails/HDFC";
import Au from "./components/BankDetails/Au";
import AXIX from "./components/BankDetails/AXIX";
import ICICI from "./components/BankDetails/ICICI";
import IDFC from "./components/BankDetails/IDFC";
import Indulnd from "./components/BankDetails/Indulnd";
import SBI from "./components/BankDetails/SBI";
import HdfcLearnMore from "./components/LearnMore/HdfcLearnMore";
import BankOfBaroda from "./components/BankDetails/BankOfBaroda";
import Citi from "./components/BankDetails/Citi";
import Federal from "./components/BankDetails/Federal";
import Hsbc from "./components/BankDetails/Hsbc";
import Kotak from "./components/BankDetails/Kotak";
import American from "./components/BankDetails/American";
import Standard from "./components/BankDetails/Standard";
import YesBank from "./components/BankDetails/YesBank";
import CashBack from "./components/topButtons/CashBack";
import Fuel from "./components/topButtons/Fuel";
import LifeTimeFee from "./components/topButtons/LifeTimeFee";
import Premium from "./components/topButtons/Premium";
import Travel from "./components/topButtons/Travel";
// import Demat from './components/demat/Demat';
import DematLearnMore from "./components/dematLearnMore/DematLearnMore";
import TermsAndConditions from "./components/privacy/TermsAndConditions";
import PrivacyPolicy from "./components/privacy/PrivacyPolicy";
import CarLoan from "./components/personalLoan/CarLoan";
import CarLoanLearnMore from "./components/LearnmorePageLoan/CarLoanLearnMore";

import HomeLoan from "./components/personalLoan/HomeLoan";
import TwoWheelerLoan from "./components/personalLoan/TwoWheelerLoan";
import EducationLoan from "./components/personalLoan/EducationLoan";
import PersonalLoanU from "./components/personalLoan/PersonalLoanU";
import AuBankLit from "./components/featuredCards/AuBankLit";
import EasyDinerBank from "./components/featuredCards/EasyDinerBank";
import HdfcBankMillennia from "./components/featuredCards/HdfcBankMillennia";
import SbiSimplyClick from "./components/featuredCards/SbiSimplyClick";
import IdfcFirstClassic from "./components/featuredCards/IdfcFirstClassic";
import FlipcartAxixBank from "./components/featuredCards/FlipcartAxixBank";
// import UpStoxLearnMore from './components/dematLearnMore/UpStoxLearnMore';
// import AngelOneLearnMore from './components/dematLearnMore/AngelOneLearnMore';
// import HdfcDematLearnMore from './components/dematLearnMore/HdfcDematLearnMore';
// import GrowwDematLearnMore from './components/dematLearnMore/GrowwDematLearnMore';
// import FyersDematLearnMore from './components/dematLearnMore/FyersDematLearnMore';
// import ZerodaDematLearnMore from './components/dematLearnMore/ZerodaDematLearnMore';
import LearnMoreAllCards from "./components/cardComponents/LearnMoreAllCards";
import IciciLombardLearn from "./components/LearnMoreCarInsurance/IciciLombardLearn";
import ToolOfSipLipPages from "./components/ToolsOfAllBanks/ToolOfSipLipPages";
import BajajLearnMore from "./components/LearnMoreCarInsurance/BajajLearnMore";
import AckoLearnMore from "./components/LearnMoreCarInsurance/AckoLearnMore";
import HdfcCarLearnMore from "./components/LearnMoreCarInsurance/HdfcCarLearnMore";
import TataAijLearnMore from "./components/LearnMoreCarInsurance/TataAijLearnMore";
import IciciBikeInsurance from "./components/LearnMoreBikeInsurance/IciciBikeInsurance";
import AckoBikeInsurance from "./components/LearnMoreBikeInsurance/AckoBikeInsurance";
import BajajBikeInsurance from "./components/LearnMoreBikeInsurance/BjajajBikeInsurance";
import FutureBikeInsurance from "./components/LearnMoreBikeInsurance/FutureBikeInsurance";
import HdfcBikeInsurance from "./components/LearnMoreBikeInsurance/HdfcBikeInsurance";
import AdityaLifeLearn from "./components/LearnMoreLifeInsurance/AdityaLifeLearn";
import FutureLifeLearn from "./components/LearnMoreLifeInsurance/FutureLifeLearn";
import HdfcLifeLearn from "./components/LearnMoreLifeInsurance/HdfcLifeLearn";
import IciciLifeLearn from "./components/LearnMoreLifeInsurance/IciciLifeLearn";
import MaxLifeLearn from "./components/LearnMoreLifeInsurance/MaxLifeLearn";
import AdityaHealthLearn from "./components/learnmoreHealthInsurance/AdityaHealthLearn";
import CareHealthLearn from "./components/learnmoreHealthInsurance/CareHealthLearn";
import HdfcargoHealthLearn from "./components/learnmoreHealthInsurance/HdfcargoHealthLearn";
import DigitHealthLearn from "./components/learnmoreHealthInsurance/DigitHealthLearn";
import RelianceHealthLearn from "./components/learnmoreHealthInsurance/RelianceHealthLearn";
import ToolsPages from "./components/ToolsOfAllBanks/ToolsPages";
import SWPCalculator from "./components/ToolsOfAllBanks/SWPCalculator";
import MutualFundCalculator from "./components/ToolsOfAllBanks/MutualFundCalculator";
import SSYCalculator from "./components/ToolsOfAllBanks/SSYCalculator";
import PPFCalculator from "./components/ToolsOfAllBanks/PPFCalculator";
import EPFCalculator from "./components/ToolsOfAllBanks/EPFCalculator";
import FDCalculator from "./components/ToolsOfAllBanks/FDCalculator";
import RDCalculator from "./components/ToolsOfAllBanks/RDCalculator";
import NPSCalculator from "./components/ToolsOfAllBanks/NPSCalculator";
import HRACalculator from "./components/ToolsOfAllBanks/HRACalculator";
import RetirementCalculator from "./components/ToolsOfAllBanks/RetirementCalculator";
import EMICalculator from "./components/ToolsOfAllBanks/EMICalculator";
import Layout from "./Layout";
import SimpleInterestCalculator from "./components/ToolsOfAllBanks/SimpleInterestCalculator";
import CompoundInterestCalculator from "./components/ToolsOfAllBanks/CompoundInterestCalculator";
import NSCCalculator from "./components/ToolsOfAllBanks/NSCCalculator";
import StepUpSIPCalculator from "./components/ToolsOfAllBanks/StepUpSIPCalculator";
import IncomeTaxCalculator from "./components/ToolsOfAllBanks/IncomeTaxCalculator";
import CarLoanEMICalculator from "./components/ToolsOfAllBanks/CarLoanEMICalculator";
import HomeLoanEMICalculator from "./components/ToolsOfAllBanks/HomeLoanEMICalculator";
import GratuityCalculator from "./components/ToolsOfAllBanks/GratuityCalculator";
import APYCalculator from "./components/ToolsOfAllBanks/APYCalculator";
import CAGRCalculator from "./components/ToolsOfAllBanks/CAGRCalculator";
import GSTCalculator from "./components/ToolsOfAllBanks/GSTCalculator";
import FlatReducingRateCalculator from "./components/ToolsOfAllBanks/FlatReducingRateCalculator";
import EquityMarginCalculator from "./components/ToolsOfAllBanks/EquityMarginCalculator";
import InflationCalculator from "./components/ToolsOfAllBanks/InflationCalculator";
import SalaryCalculator from "./components/ToolsOfAllBanks/SalaryCalculator";
import BrokerageCalculator from "./components/ToolsOfAllBanks/BrokerageCalculator";
import TDSCalculator from "./components/ToolsOfAllBanks/TDSCalculator";
// import LumpsumCalculator from './components/ToolsOfAllBanks/LumpsumCalculator';
import SiteMapUi from "./components/sitemap/SiteMapUi";
import LayoutGTM from "./LayoutGTM";
import LayoutScroll from "./LayoutScroll";
import Blogs from "./components/blog/Blogs";
// import SinglepageBlog from './components/blog/SinglepageBlog';
import BajajTravelLearn from "./components/LearnMoreTravelInsurance.js/BajajTravelLearn";
import IciciLombardTravelLearn from "./components/LearnMoreTravelInsurance.js/IciciLombardTravelLearn";
import TataaijTravelLearn from "./components/LearnMoreTravelInsurance.js/TataaijTavelLearn";
import CareHealthTravelLearn from "./components/LearnMoreTravelInsurance.js/CareHealthTravelLearn";
import HdfcErgoTravelLearn from "./components/LearnMoreTravelInsurance.js/HdfcErgoTravelLearn";
import LoanMainPage from "./components/LoanPages/LoanMainPage";
import SingleLoanPage from "./components/LoanPages/SingleLoanPage";
import DematMainPage from "./components/demat/DematMainPage";
import SingleDematPage from "./components/demat/SingleDematPage";
import InsuranceMainPage from "./components/InsuranceNewUi/InsuranceMainPage";
import SingleInsurancePage from "./components/InsuranceNewUi/SingleInsurancePage";
// import ScrollToHashElement from './components/ScrollToHashElement';
import CarInsuranceNew from "./components/AllInsuranceDynamic/CarInsuranceNew";
import CarInsuranceDetail from "./components/AllInsuranceDynamic/CarInsuranceDetail";
import BikeInsuranceNew from "./components/AllInsuranceDynamic/BikeInsuranceNew";
import BikeInsuranceDetail from "./components/AllInsuranceDynamic/BikeInsuranceDetail";
import TravelInsuranceNew from "./components/AllInsuranceDynamic/TravelInsuranceNew";
import HealthInsuranceNew from "./components/AllInsuranceDynamic/HealthInsuranceNew";
import TermLifeInsuranceNew from "./components/AllInsuranceDynamic/TermLifeInsuranceNew";
import CarLoanNew from "./components/AllLoanDynamic/CarLoanNew";
import CarLoanDetail from "./components/AllLoanDynamic/CarLoanDetail";
import TermInsuranceDetail from "./components/AllInsuranceDynamic/TermInsuranceDetail";
import HealthInsuranceDetail from "./components/AllInsuranceDynamic/HealthInsuranceDetail";
import TravelInsuranceDetail from "./components/AllInsuranceDynamic/TravelInsuranceDetail";
import HomeLoanNew from "./components/AllLoanDynamic/HomeLoanNew";
import PersonalLoanNew from "./components/AllLoanDynamic/PersonalLoanNew";
import EducationLoanNew from "./components/AllLoanDynamic/EducationLoanNew";
import TwoWheelerLoanNew from "./components/AllLoanDynamic/TwoWheelerLoanNew";
import GoldLoanNew from "./components/AllLoanDynamic/GoldLoanNew";
import BusinessLoanNew from "./components/AllLoanDynamic/BusinessLoanNew";
import NavBarNew from "./components/NavbarNew";
import EducationLoanDetail from "./components/AllLoanDynamic/EducationLoanDetail";
import PersonalLoanDetail from "./components/AllLoanDynamic/PersonalLoanDetail";
import HomeLoanDetail from "./components/AllLoanDynamic/HomeLoanDetail";
import BusinessLoanDetail from "./components/AllLoanDynamic/BusinessLoanDetail";
import GoldLoanDetail from "./components/AllLoanDynamic/GoldLoanDetail";
import KotakMahindra from "./components/BankDetails/KotakMahindra";
import Rbl from "./components/BankDetails/Rbl";
import PnbBank from "./components/BankDetails/PnbBank";
import UnionBank from "./components/BankDetails/UnionBanks";
import CanaraBank from "./components/BankDetails/CanaraBank";
import BoiBank from "./components/BankDetails/Boi";
import DBS from "./components/BankDetails/DBS";
import IndianBank from "./components/BankDetails/IndianBank";
import UjjivanBank from "./components/BankDetails/UjjivanBank";
import Equitas from "./components/BankDetails/Equitas";
import CityBank from "./components/BankDetails/CityBank";
import SouthIndianBank from "./components/BankDetails/SouthIndianBank";
import DcbBank from "./components/BankDetails/DcbBank";
import JKBank from "./components/BankDetails/JKBank";
import KvbBank from "./components/BankDetails/KvbBank";
import ContactModal from "./components/contact/ContactModal";
import InsuranceNewUiHome from "./components/AllInsuranceDynamic/InsuranceNewUiHome";
import LoanInsuranceNewUiHome from "./components/AllLoanDynamic/LoanInsuranceNewUiHome";
// import BlogNewUiPage from './components/blog/BlogNewUiPage';
import SingleBlogNew from "./components/blog/SingleBlogNew";
import TwoWheelerLoanDetail from "./components/AllLoanDynamic/TwoWheelerLoanDetail";
import RewardCredit from "./components/topButtons/RewardCredit";
import BusinessCreditCard from "./components/topButtons/BuisnessCreditCard";
import LifeStyleCreditCard from "./components/topButtons/LifeStyleCreditCard";
// import TermLifeInsurance from './components/ToolsOfAllBanks/TermLifeInsurance';
import TermLifeInsuranceCalculator from "./components/ToolsOfAllBanks/TermLifeInsuranceCalculator";
import TravelInsuranceCalculator from "./components/ToolsOfAllBanks/TravelLifeInsuranceCalculator";
import CarInsuranceCalculator from "./components/ToolsOfAllBanks/CarInsuranceCalculator";
import BikeInsuranceCalculator from "./components/ToolsOfAllBanks/BikeInsuranceCalculator";
import HealthInsuranceCalculator from "./components/ToolsOfAllBanks/HealthInsuranceCalculator";
import HdfcSipCalculator from "./components/ToolsOfAllBanks/HdfcSipCalculator";
import IciciSipCalculator from "./components/ToolsOfAllBanks/IciciSipCalculator";
import AxixSipCalculator from "./components/ToolsOfAllBanks/AxixSipCalculator";
import KotakSipCalculator from "./components/ToolsOfAllBanks/KotakSipCalculator";
import CanaraBankCalculator from "./components/ToolsOfAllBanks/CanaraBankCalculator";
import SbiSipCalculator from "./components/ToolsOfAllBanks/SbiSipCalculator";
import NipponSipCalculator from "./components/ToolsOfAllBanks/NipponSipCalculator";
import LicSipCalculator from "./components/ToolsOfAllBanks/LicSipBankCalculator";
import PnbSipCalculator from "./components/ToolsOfAllBanks/PnbSipCalculator";
import IDBISipCalculator from "./components/ToolsOfAllBanks/IDBISipCalculator";
import GoldLoanEmiCalculator from "./components/ToolsOfAllBanks/GoldLoanEmiCalculator";
import PersonalLoanEmiCalculator from "./components/ToolsOfAllBanks/PersonalLoanEmiCalculator";
import BusinessLoanEmiCalculator from "./components/ToolsOfAllBanks/BusinessLoanEmiCalculator";
import EducationLoanEmiCalculator from "./components/ToolsOfAllBanks/EducationLoanEmiCalculator";
import TwowheelerLoanEmiCalculator from "./components/ToolsOfAllBanks/TwowheelerLoanEmiCalculator";
import SbiLoanEmiCalculator from "./components/ToolsOfAllBanks/SbiLoanEmiCalculator";
import AxixCarLoanEmiCalculator from "./components/ToolsOfAllBanks/AxixCarLoanEmiCalculator";
import IciciCarloanEmiCalculator from "./components/ToolsOfAllBanks/IciciCarloanEmiCalculator";
import HdfcCarLoanEmiCalculator from "./components/ToolsOfAllBanks/HdfcCarLoanEmiCalculator";
import CanaraCarLoanEmiCalculator from "./components/ToolsOfAllBanks/CanaraCarLoanEmiCalculator";
import PnbCarLoanEmiCalculator from "./components/ToolsOfAllBanks/PnbCarLoanEmiCalculator";
import UninonBankCarLoanEmiCalculator from "./components/ToolsOfAllBanks/UninonBankCarLoanEmiCalculator";
import BobCarLoanEmiCalculator from "./components/ToolsOfAllBanks/BobCarLoanEmiCalculator";
import BomCarLoanEmiCalculator from "./components/ToolsOfAllBanks/BomCarLoanEmiCalculator";
import DhanlaxmiCarloanEMiCalculator from "./components/ToolsOfAllBanks/DhanlaxmiCarloanEMiCalculator";
import SbiBikeLoanEmiCalculator from "./components/ToolsOfAllBanks/SbiBikeLoanEmiCalculator";
import HdfcBikeLoanEmiCalculator from "./components/ToolsOfAllBanks/HdfcBikeLoanEmiCalculator";
import IciciBankBikeLoanEmi from "./components/ToolsOfAllBanks/IciciBankBikeLoanEmi";
import AxixBankBikeloanEmi from "./components/ToolsOfAllBanks/AxixBankBikeloanEmi";
import BajajFinserveBikeloanEmi from "./components/ToolsOfAllBanks/BajajFinserveBikeloanEmi";
import KotakMahindraBikeEMiCalculator from "./components/ToolsOfAllBanks/KotakMahindraBikeEMiCalculator";
import TataCapitalBikeEmiCalculator from "./components/ToolsOfAllBanks/TataCapitalBikeEmiCalculator";
import MahindraFinanceBikeEmi from "./components/ToolsOfAllBanks/MahindraFinanceBikeLoanEmi";
import MuthootFinanceBikeLoanEmi from "./components/ToolsOfAllBanks/MuthootFinanceBikeLoanEmi";
import SbihomeLoanEmiCalculator from "./components/ToolsOfAllBanks/SbihomeLoanEmiCalculator";
import HdfcHomeLoanEMiCalculator from "./components/ToolsOfAllBanks/HdfcHomeLoanEMiCalculator";
import IciciHomeLoanEmiCalculator from "./components/ToolsOfAllBanks/IciciHomeLoanEmiCalculator";
import AxisHomeLoanEmiCalculator from "./components/ToolsOfAllBanks/AxisHomeLoanEmiCalculator";
import LicHousingFinanceHomeLoan from "./components/ToolsOfAllBanks/LicHousingFinanceHomeLoan";
import BobHomeLoanEmiCalculator from "./components/ToolsOfAllBanks/BobHomeLoanEmiCalculator";
import { NotAccessibleTwoTone } from "@mui/icons-material";
import NotFound from "./components/NoPage/NotFound";
import CanaraHomeLoanEmiCal from "./components/ToolsOfAllBanks/CanaraHomeLoanEmiCal";
import UBIHomeLoanEmiCal from "./components/ToolsOfAllBanks/UBIHomeLoanEmiCal";
import IobHomeLoanEmiCal from "./components/ToolsOfAllBanks/IobHomeLoanEmiCal";
import PnbHomeLoanEmiCal from "./components/ToolsOfAllBanks/PnbHomeLoanEmiCal";
import HdfcPersonalLoanEmiCal from "./components/ToolsOfAllBanks/HdfcPersonalLoanEmiCal";
import AxisPersonalLoanEmiCal from "./components/ToolsOfAllBanks/AxisPersonalLoanEmiCal";
import IciciPersonalLoanEmiCal from "./components/ToolsOfAllBanks/IciciPersonalLoanEmiCal";
import KotakPersonalLoanEmiCal from "./components/ToolsOfAllBanks/KotakPersonalLoanEmiCal";
import IndusindPersonalLoanEmiCal from "./components/ToolsOfAllBanks/IndusindPersonalLoanEmiCal";
import YesBankPersonalLoanEmiCal from "./components/ToolsOfAllBanks/YesBankPersonalLoanEmiCal";
import FederalPersonalLoanEMiCal from "./components/ToolsOfAllBanks/FederalPersonalLoanEMiCal";
import IdfcPersonalLoanEmiCal from "./components/ToolsOfAllBanks/IdfcPersonalLoanEmiCal";
import CitiPersonalLoanEmiCalc from "./components/ToolsOfAllBanks/CitiPersonalLoanEmiCalc";
import StandardCharteredPersonalEmiCal from "./components/ToolsOfAllBanks/StandardCharteredPersonalEmiCal";
import SbiGoldLoanEmiCalcu from "./components/ToolsOfAllBanks/SbiGoldLoanEmiCalcu";
import HdfcGoldLoanEmiCal from "./components/ToolsOfAllBanks/HdfcGoldLoanEmiCal";
import KotakGoldLoanEmiCal from "./components/ToolsOfAllBanks/KotakGoldLoanEmiCal";
import MutootFinanceGoldLoanEmiCal from "./components/ToolsOfAllBanks/MutootFinanceGoldLoanEmiCal";
import CentralBOIGoldLoanEmiCal from "./components/ToolsOfAllBanks/CentralBOIGoldLoanEmiCal";
import IndianBankGoldLoanEmiCal from "./components/ToolsOfAllBanks/IndianBankGoldLoanEmiCal";
import IciciGoldLoanEmiCal from "./components/ToolsOfAllBanks/IciciGoldLoanEmiCal";
import AxisGoldLoanEmiCal from "./components/ToolsOfAllBanks/AxisGoldLoanEmiCal";
import CaneraBankGoldLoanEmiCal from "./components/ToolsOfAllBanks/CaneraBankGoldLoanEmiCal";
import BobGoldLoanEmiCal from "./components/ToolsOfAllBanks/BobGoldLoanEmiCal";
import SbiEducationLoanEmiCal from "./components/ToolsOfAllBanks/SbiEducationLoanEmiCal";
import HdfcEducationLoanEmiCal from "./components/ToolsOfAllBanks/HdfcEducationLoanEmiCal";
import IciciEducationLoanEmiCal from "./components/ToolsOfAllBanks/IciciEducationLoanEmiCal";
import AxisEducationLoanEmiCal from "./components/ToolsOfAllBanks/AxisEducationLoanEmiCal";
import PnbEducationLoanEMiCal from "./components/ToolsOfAllBanks/PnbEducationLoanEMiCal";
import BobEducationLoanEmiCal from "./components/ToolsOfAllBanks/BobEducationLoanEmiCal";
import KotakEducationLoanEmiCal from "./components/ToolsOfAllBanks/KotakEducationLoanEmiCal";
import CanaraEducationLoanEmiCal from "./components/ToolsOfAllBanks/CanaraEducationLoanEmiCal";
import IdfcEducationLoanEmiCalcu from "./components/ToolsOfAllBanks/IdfcEducationLoanEmiCalcu";
import FederalEducationLoanEmiCal from "./components/ToolsOfAllBanks/FederalEducationLoanEmiCal";
import SbiBusinessLoanEmiCal from "./components/ToolsOfAllBanks/SbiBusinessLoanEmiCal";
import HdfcBusinessLoanEmiCal from "./components/ToolsOfAllBanks/HdfcBusinessLoanEmiCal";
import IciciBusinessLoanEmiCal from "./components/ToolsOfAllBanks/IciciBusinessLoanEmiCal";
import AxisBusinessLoanEmiCal from "./components/ToolsOfAllBanks/AxisBusinessLoanEmiCal";
import BobBusinessLoanEmiCal from "./components/ToolsOfAllBanks/BobBusinessLoanEmiCal";
import KotakBusinessLoanEmiCal from "./components/ToolsOfAllBanks/KotakBusinessLoanEmiCal";
import PnbBusinessLoanEmiCal from "./components/ToolsOfAllBanks/PnbBusinessLoanEmiCal";
import IdfcBusinessLoanEmiCal from "./components/ToolsOfAllBanks/IdfcBusinessLoanEmiCal";
import UnionBusinessLoanEmiCal from "./components/ToolsOfAllBanks/UnionBusinessLoanEmiCal";
import CanaraBusinessLoanEmiCal from "./components/ToolsOfAllBanks/CanaraBusinessLoanEmiCal";
import MarutiSuzukiCarInsurance from "./components/CarInsuranceExtraPages/MarutiSuzukiCarInsurance";
import HyundaiCarInsurance from "./components/CarInsuranceExtraPages/HyundaiCarInsurance";
import TataCarInsurance from "./components/CarInsuranceExtraPages/TataCarInsurance";
import MahindraCarInsurance from "./components/CarInsuranceExtraPages/MahindraCarInsurance";
import KiaCarInsurance from "./components/CarInsuranceExtraPages/KiaCarInsurance";
import ToyotaCarInsurance from "./components/CarInsuranceExtraPages/ToyotaCarInsurance";
import NissanCarInsurance from "./components/CarInsuranceExtraPages/NissanCarInsurance";
import SkodaCarInsurance from "./components/CarInsuranceExtraPages/SkodaCarInsurance";
import MGCarInsurance from "./components/CarInsuranceExtraPages/MgCarInsurance";
import HondaCarInsurance from "./components/CarInsuranceExtraPages/HondaCarInsurance";
import RenaultCarInsurance from "./components/CarInsuranceExtraPages/RenaultCarInsurance";
import VolkswagenCarInsurance from "./components/CarInsuranceExtraPages/VolkswagenCarInsurance";
import MercedesBenzCarInsurance from "./components/LuxuryCarInsurance/MercedesBenzCarInsurance";
import BMWCarInsurance from "./components/LuxuryCarInsurance/BMWCarInsurance";
import AudiCarInsurance from "./components/LuxuryCarInsurance/AudiCarInsurance";
import VolvoCarInsurance from "./components/LuxuryCarInsurance/VolvoCarInsurance";
import LexusCarInsurance from "./components/LuxuryCarInsurance/LexusCarInsurance";
import JaguarLandRoverCarInsurance from "./components/LuxuryCarInsurance/JaguarLandRoverCarInsurance";
import PorscheCarInsurance from "./components/LuxuryCarInsurance/PorscheCarInsurance";
import HeroMotoCorpTwoWheelerInsurance from "./components/TwoWheelerBrandPage/HeroMotoCorpTwoWheelerInsurance";
import HondaTwoWheelerInsurance from "./components/TwoWheelerBrandPage/HondaTwoWheelerInsurance";
import TVSTwoWheelerInsurance from "./components/TwoWheelerBrandPage/TVSTwoWheelerInsurance";
import BajajTwoWheelerInsurance from "./components/TwoWheelerBrandPage/BajajTwoWheelerInsurance";
import SuzukiTwoWheelerInsurance from "./components/TwoWheelerBrandPage/SuzukiTwoWheelerInsurance";
import YamahaTwoWheelerInsurance from "./components/TwoWheelerBrandPage/YamahaTwoWheelerInsurance";
import RoyalEnfieldTwoWheelerInsurance from "./components/TwoWheelerBrandPage/RoyalEnfieldTwoWheelerInsurance";
import AtherElectricScooterInsurance from "./components/TwoWheelerBrandPage/AtherElectricScooterInsurance";
import OlaElectricScooterInsurance from "./components/TwoWheelerBrandPage/OlaElectricScooterInsurance";
import RevoltElectricBikeInsurance from "./components/TwoWheelerBrandPage/RevoltElectricBikeInsurance";
import KTMBikeInsurance from "./components/TwoWheelerBrandPage/KTMBikeInsurance";
import HarleyDavidsonBikeInsurance from "./components/TwoWheelerBrandPage/HarleyDavidsonBikeInsurance";
import TriumphBikeInsurance from "./components/TwoWheelerBrandPage/TriumphBikeInsurance";
import MarutiSuzukiCarLoan from "./components/CarloanBrandsPagesExtra/MarutiSuzukiCarLoan";
import HyundaiCarLoan from "./components/CarloanBrandsPagesExtra/HyundaiCarLoan";
import TataMotorsCarLoan from "./components/CarloanBrandsPagesExtra/TataMotorsCarLoan";
import MahindraCarLoan from "./components/CarloanBrandsPagesExtra/MahindraCarLoan";
import KiaCarLoan from "./components/CarloanBrandsPagesExtra/KiaCarLoan";
import ToyotaCarLoan from "./components/CarloanBrandsPagesExtra/ToyotaCarLoan";
import NissanCarLoan from "./components/CarloanBrandsPagesExtra/NissanCarLoan";
import SkodaCarLoan from "./components/CarloanBrandsPagesExtra/SkodaCarLoan";
import MgCarLoan from "./components/CarloanBrandsPagesExtra/MgCarLoan";
import HondaCarLoan from "./components/CarloanBrandsPagesExtra/HondaCarLoan";
import RenaultCarLoan from "./components/CarloanBrandsPagesExtra/RenaultCarLoan";
import VolkswagenCarLoan from "./components/CarloanBrandsPagesExtra/VolkswagenCarLoan";
import MercedesBenzCarLoan from "./components/CarloanBrandsPagesExtra/MercedesBenzCarLoan";
import BMWCarLoan from "./components/CarloanBrandsPagesExtra/BMWCarLoan";
import AudiCarLoan from "./components/CarloanBrandsPagesExtra/AudiCarLoan";
import VolvoCarLoan from "./components/CarloanBrandsPagesExtra/VolvoCarLoan";
import LexusCarLoan from "./components/CarloanBrandsPagesExtra/LexusCarLoan";
import JaguarCarLoan from "./components/CarloanBrandsPagesExtra/JaguarCarLoan";
import PorscheCarLoan from "./components/CarloanBrandsPagesExtra/PorscheCarLoan";
import HeroMotoCorpTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/HeroMotoCorpTwoWheelerLoan";
import HondaTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/HondaTwoWheelerLoan";
import TVSTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/TVSTwoWheelerLoan";
import BajajTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/BajajTwoWheelerLoan";
import SuzukiTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/SuzukiTwoWheelerLoan";
import YamahaTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/YamahaTwoWheelerLoan";
import RoyalEnfieldTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/RoyalEnfieldTwoWheelerLoan";
import AtherTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/AtherTwoWheelerLoan";
import OlaTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/OlaTwoWheelerLoan";
import RevoltTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/RevoltTwoWheelerLoan";
import KtmTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/KtmTwoWheelerLoan";
import BmwMotorradTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/BmwMotorradWheelerLoan";
import HarleyDavidsonTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/HarleyDavidsonTwoWheelerLoan";
import TriumphTwoWheelerLoan from "./components/TwowheelerLoanBrandPages/TriumphTwoWheelerLoan";
import BMWMotorradInsurance from "./components/TwoWheelerBrandPage/BMWMotorradInsurance";
import MarutiSuzukiAltoCarInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiAltoCarInsurance";
import MarutiSuzukiWagonRInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiWagonRInsurance";
import MarutiSuzukiSwiftInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiSwiftInsurance";
import MarutiSuzukiBalenoInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiBalenoInsurance";
import MarutiSuzukiDzireInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiDzireInsurance";
import MarutiSuzukiErtigaInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiErtigaInsurance";
import MarutiSuzukiBrezzaInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiBrezzaInsurance";
import MarutiSuzukiFronxInsurance from "./components/MarutiSuzukiCarInsurance/MarutiSuzukiFronxInsurance";
import HyundaiCretaInsurance from "./components/HyundaiCarinsurancePages/HyundaiCretaInsurance";
import HyundaiVenueInsurance from "./components/HyundaiCarinsurancePages/HyundaiVenueInsurance";
import HyundaiExterInsurance from "./components/HyundaiCarinsurancePages/HyundaiExterInsurance";
import HyundaiI20Insurance from "./components/HyundaiCarinsurancePages/HyundaiI20Insurance";
import HyundaiGrandI10NiosInsurance from "./components/HyundaiCarinsurancePages/HyundaiGrandI10NiosInsurance";
import HyundaiVernaInsurance from "./components/HyundaiCarinsurancePages/HyundaiVernaInsurance";
import HyundaiAlcazarInsurance from "./components/HyundaiCarinsurancePages/HyundaiAlcazarInsurance";
import HyundaiTucsonInsurance from "./components/HyundaiCarinsurancePages/HyundaiTucsonInsurance";
import TataNexonInsurance from "./components/TataCarInsurancesPages/TataNexonInsurance";
import TataPunchInsurance from "./components/TataCarInsurancesPages/TataPunchInsurance";
import TataHarrierInsurance from "./components/TataCarInsurancesPages/TataHarrierInsurance";
import TataSafariInsurance from "./components/TataCarInsurancesPages/TataSafariInsurance";
import TataAltrozInsurance from "./components/TataCarInsurancesPages/TataAltrozInsurance";
import TataTiagoInsurance from "./components/TataCarInsurancesPages/TataTiagoInsurance";
import TataTigorInsurance from "./components/TataCarInsurancesPages/TataTigorInsurance";
import TataCurvvInsurance from "./components/TataCarInsurancesPages/TataCurvvInsurance";
import MahindraScorpioNInsurance from "./components/MahindraCarInuranceBrand/MahindraScorpioNInsurance";
import MahindraXUV700Insurance from "./components/MahindraCarInuranceBrand/MahindraXUV700Insurance";
import MahindraTharInsurance from "./components/MahindraCarInuranceBrand/MahindraTharInsurance";
import MahindraBoleroNeoInsurance from "./components/MahindraCarInuranceBrand/MahindraBoleroNeoInsurance";
import MahindraXUV300Insurance from "./components/MahindraCarInuranceBrand/MahindraXUV300Insurance";
import MahindraBoleroInsurance from "./components/MahindraCarInuranceBrand/MahindraBoleroInsurance";
import MahindraMarazzoInsurance from "./components/MahindraCarInuranceBrand/MahindraMarazzoInsurance";
import MahindraXUV400Insurance from "./components/MahindraCarInuranceBrand/MahindraXUV400Insurance";
import KiaSeltosInsurance from "./components/KiaCarInsuranceBrandPages/KiaSeltosInsurance";
import KiaSonetInsurance from "./components/KiaCarInsuranceBrandPages/KiaSonetInsurance";
import KiaCarensInsurance from "./components/KiaCarInsuranceBrandPages/KiaCarensInsurance";
import KiaEV6Insurance from "./components/KiaCarInsuranceBrandPages/KiaEV6Insurance";
import KiaCarnivalInsurance from "./components/KiaCarInsuranceBrandPages/KiaCarnivalInsurance";
import KiaSportageInsurance from "./components/KiaCarInsuranceBrandPages/KiaSportageInsurance";
import KiaRioInsurance from "./components/KiaCarInsuranceBrandPages/KiaRioInsurance";
import ToyotaInnovaCrystaInsurance from "./components/ToyotaCarInsurancePages/ToyotaInnovaCrystaInsurance";
import ToyotaInnovaHycrossInsurance from "./components/ToyotaCarInsurancePages/ToyotaInnovaHycrossInsurance";
import ToyotaUrbanCruiserHyryderInsurance from "./components/ToyotaCarInsurancePages/ToyotaUrbanCruiserHyryderInsurance";
import ToyotaGlanzaInsurance from "./components/ToyotaCarInsurancePages/ToyotaGlanzaInsurance";
import ToyotaHiluxInsurance from "./components/ToyotaCarInsurancePages/ToyotaHiluxInsurance";
import ToyotaCamryInsurance from "./components/ToyotaCarInsurancePages/ToyotaCamryInsurance";
import ToyotaVellfireInsurance from "./components/ToyotaCarInsurancePages/ToyotaVellfireInsurance";
import ToyotaFortunerInsurance from "./components/ToyotaCarInsurancePages/ToyotaFortunerInsurance";
import KiaEV9Insurance from "./components/KiaCarInsuranceBrandPages/KiaEV9Insurance";
import NissanMagniteInsurance from "./components/NissanCarinsuranceBrand/NissanMagniteInsurance";
import NissanKicksInsurance from "./components/NissanCarinsuranceBrand/NissanKicksInsurance";
import NissanGTRInsurance from "./components/NissanCarinsuranceBrand/NissanGTRInsurance";
import NissanSunnyInsurance from "./components/NissanCarinsuranceBrand/NissanSunnyInsurance";
import SkodaSlaviaInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaSlaviaInsurance";
import SkodaKushaqInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaKushaqInsurance";
import SkodaKodiaqInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaKodiaqInsurance";
import SkodaSuperbInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaSuperbInsurance";
import SkodaRapidInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaRapidInsurance";
import SkodaLauraInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaLauraInsurance";
import SkodaFabiaInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaFabiaInsurance";
import SkodaOctaviaInsurance from "./components/SkodaCarInsuranceBrandPages/SkodaOctaviaInsurance";
import MGHectorInsurance from "./components/MgCarInsuranceBrandPages/MGHectorInsurance";
import MGHectorPlusInsurance from "./components/MgCarInsuranceBrandPages/MGHectorPlusInsurance";
import MGAstorInsurance from "./components/MgCarInsuranceBrandPages/MGAstorInsurance";
import MGCometEVInsurance from "./components/MgCarInsuranceBrandPages/MGCometEVInsurance";
import MGZSEVInsurance from "./components/MgCarInsuranceBrandPages/MGZSEVInsurance";
import MGGlosterInsurance from "./components/MgCarInsuranceBrandPages/MGGlosterInsurance";
import MGRC6Insurance from "./components/MgCarInsuranceBrandPages/MGRC6Insurance";
import MGMarvelXInsurance from "./components/MgCarInsuranceBrandPages/MGMarvelXInsurance";
import HondaCityInsurance from "./components/HondaCarInsuranceBrandPages/HondaCityInsurance";
import HondaAmazeInsurance from "./components/HondaCarInsuranceBrandPages/HondaAmazeInsurance";
import HondaElevateInsurance from "./components/HondaCarInsuranceBrandPages/HondaElevateInsurance";
import HondaWRVInsurance from "./components/HondaCarInsuranceBrandPages/HondaWRVInsurance";
import HondaJazzInsurance from "./components/HondaCarInsuranceBrandPages/HondaJazzInsurance";
import HondaCityHybridInsurance from "./components/HondaCarInsuranceBrandPages/HondaCityHybridInsurance";
import HondaAccordHybridInsurance from "./components/HondaCarInsuranceBrandPages/HondaAccordHybridInsurance";
import HondaCRVInsurance from "./components/HondaCarInsuranceBrandPages/HondaCRVInsurance";
import RenaultKwidInsurance from "./components/RenaultCarInsuranceBrandPages/RenaultKwidInsurance";
import RenaultKigerInsurance from "./components/RenaultCarInsuranceBrandPages/RenaultKigerInsurance";
import RenaultTriberInsurance from "./components/RenaultCarInsuranceBrandPages/RenaultTriberInsurance";
import RenaultDusterInsurance from "./components/RenaultCarInsuranceBrandPages/RenaultDusterInsurance";
import VolkswagenVirtusInsurance from "./components/VolkswagenCarInsuranceBrandPages/VolkswagenVirtusInsurance";
import VolkswagenTaigunInsurance from "./components/VolkswagenCarInsuranceBrandPages/VolkswagenTaigunInsurance";
import VolkswagenGolfGTIInsurance from "./components/VolkswagenCarInsuranceBrandPages/VolkswagenGolfGTIInsurance";
import VolkswagenTiguanInsurance from "./components/VolkswagenCarInsuranceBrandPages/VolkswagenTiguanInsurance";
import VolkswagenPoloInsurance from "./components/VolkswagenCarInsuranceBrandPages/VolkswagenPoloInsurance";
import VolkswagenID4Insurance from "./components/VolkswagenCarInsuranceBrandPages/VolkswagenID4Insurance";
import MercedesBenzGLAInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzGLAInsurance";
import MercedesBenzGLCInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzGLCInsurance";
import MercedesBenzGLEInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzGLEInsurance";
import MercedesBenzGLSInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzGLSInsurance";
import MercedesBenzAClassLimousineInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzAClassLimousineInsurance";
import MercedesBenzCClassInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzCClassInsurance";
import MercedesBenzEClassInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzEClassInsurance";
import MercedesBenzSClassInsurance from "./components/MercedesBenzCarInsurancepages/MercedesBenzSClassInsurance";
import BMWX1Insurance from "./components/BMWCarInsuranceBrandPages/BMWX1Insurance";
import BMW3SeriesInsurance from "./components/BMWCarInsuranceBrandPages/BMW3SeriesInsurance";
import BMW5SeriesInsurance from "./components/BMWCarInsuranceBrandPages/BMW5SeriesInsurance";
import BMW7SeriesInsurance from "./components/BMWCarInsuranceBrandPages/BMW7SeriesInsurance";
import BMWX3Insurance from "./components/BMWCarInsuranceBrandPages/BMWX3Insurance";
import BMWX5Insurance from "./components/BMWCarInsuranceBrandPages/BMWX5Insurance";
import BMWiXInsurance from "./components/BMWCarInsuranceBrandPages/BMWiXInsurance";
import BMWZ4Insurance from "./components/BMWCarInsuranceBrandPages/BMWZ4Insurance";
import AudiA4Insurance from "./components/AudiCarBrandCarInsurances/AudiA4Insurance";
import AudiA6Insurance from "./components/AudiCarBrandCarInsurances/AudiA6Insurance";
import AudiA8LInsurance from "./components/AudiCarBrandCarInsurances/AudiA8LInsurance";
import AudiQ3Insurance from "./components/AudiCarBrandCarInsurances/AudiQ3Insurance";
import AudiQ5Insurance from "./components/AudiCarBrandCarInsurances/AudiQ5Insurance";
import AudiQ7Insurance from "./components/AudiCarBrandCarInsurances/AudiQ7Insurance";
import AudiQ8Insurance from "./components/AudiCarBrandCarInsurances/AudiQ8Insurance";
import AudiEtronInsurance from "./components/AudiCarBrandCarInsurances/AudiEtronInsurance";
import VolvoXC60Insurance from "./components/VolvoCarBrandCarinsurancePages/VolvoXC60Insurance";
import VolvoXC90Insurance from "./components/VolvoCarBrandCarinsurancePages/VolvoXC90Insurance";
import VolvoC40RechargeInsurance from "./components/VolvoCarBrandCarinsurancePages/VolvoC40RechargeInsurance";
import VolvoXC40RechargeInsurance from "./components/VolvoCarBrandCarinsurancePages/VolvoXC40RechargeInsurance";
import VolvoS90Insurance from "./components/VolvoCarBrandCarinsurancePages/VolvoS90Insurance";
import LexusESInsurance from "./components/LexusCarbrandPageCarInsurance/LexusESInsurance";
import LexusNXInsurance from "./components/LexusCarbrandPageCarInsurance/LexusNXInsurance";
import LexusRXInsurance from "./components/LexusCarbrandPageCarInsurance/LexusRXInsurance";
import LexusLXInsurance from "./components/LexusCarbrandPageCarInsurance/LexusLXInsurance";
import LexusLMInsurance from "./components/LexusCarbrandPageCarInsurance/LexusLMInsurance";
import LexusLCInsurance from "./components/LexusCarbrandPageCarInsurance/LexusLCInsurance";
import JaguarFPaceInsurance from "./components/JaguarCarInsurancesCarBrandPage/JaguarFPaceInsurance";
import JaguarIPaceInsurance from "./components/JaguarCarInsurancesCarBrandPage/JaguarIPaceInsurance";
import JaguarXEInsurance from "./components/JaguarCarInsurancesCarBrandPage/JaguarXEInsurance";
import JaguarFTypeInsurance from "./components/JaguarCarInsurancesCarBrandPage/JaguarFTypeInsurance";
import JaguarXFInsurance from "./components/JaguarCarInsurancesCarBrandPage/JaguarXFInsurance";
import PorscheMacanInsurance from "./components/PorscheCarInsuranceCarBrandPages/PorscheMacanInsurance";
import PorscheCayenneInsurance from "./components/PorscheCarInsuranceCarBrandPages/PorscheCayenneInsurance";
import PorscheCayenneCoupeInsurance from "./components/PorscheCarInsuranceCarBrandPages/PorscheCayenneCoupeInsurance";
import PorschePanameraInsurance from "./components/PorscheCarInsuranceCarBrandPages/PorschePanameraInsurance";
import Porsche911Insurance from "./components/PorscheCarInsuranceCarBrandPages/Porsche911Insurance";
import PorscheTaycanInsurance from "./components/PorscheCarInsuranceCarBrandPages/PorscheTaycanInsurance";
import Porsche718Insurance from "./components/PorscheCarInsuranceCarBrandPages/Porsche718Insurance";
import HeroSplendorPlusInsurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroSplendorPlusInsurance";
import HeroHFDeluxeInsurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroHFDeluxeInsurance";
import HeroXtreme125RInsurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroXtreme125RInsurance";
import HeroGlamourXTECInsurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroGlamourXTECInsurance";
import HeroSuperSplendorXTECInsurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroSuperSplendorXTECInsurance";
import HeroKarizmaXMR250Insurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroKarizmaXMR250Insurance";
import HeroXPulse421Insurance from "./components/HeroMotoBikeBrandPagesInsurance/HeroXPulse421Insurance";
import HondaActivaInsurance from "./components/HondaBrandBikeInsurancePage/HondaActivaInsurance";
import HondaShine125Insurance from "./components/HondaBrandBikeInsurancePage/HondaShine125Insurance";
import HondaSP125Insurance from "./components/HondaBrandBikeInsurancePage/HondaSP125Insurance";
import HondaUnicornInsurance from "./components/HondaBrandBikeInsurancePage/HondaUnicornInsurance";
import HondaCB200XInsurance from "./components/HondaBrandBikeInsurancePage/HondaCB200XInsurance";
import HondaCB350HnessInsurance from "./components/HondaBrandBikeInsurancePage/HondaCB350HnessInsurance";
import HondaCB750HornetInsurance from "./components/HondaBrandBikeInsurancePage/HondaCB750HornetInsurance";
import TVSJupiterInsurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSJupiterInsurance";
import TVSRaider125Insurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSRaider125Insurance";
import TVSApacheRTR1604VInsurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSApacheRTR1604VInsurance";
import TVSiQubeInsurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSiQubeInsurance";
import TVSNtorq125Insurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSNtorq125Insurance";
import TVSSportInsurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSSportInsurance";
import TVSRadeonInsurance from "./components/TvsBikeInsuranceBikeBrandPage/TVSRadeonInsurance";
import BajajPulsar125Insurance from "./components/BajajBrandBikeInsurancePages/BajajPulsar125Insurance";
import BajajPlatinaInsurance from "./components/BajajBrandBikeInsurancePages/BajajPlatinaInsurance";
import BajajPulsar200Insurance from "./components/BajajBrandBikeInsurancePages/BajajPulsar200Insurance";
import BajajChetakInsurance from "./components/BajajBrandBikeInsurancePages/BajajChetakInsurance";
import BajajPulsarNS400ZInsurance from "./components/BajajBrandBikeInsurancePages/BajajPulsarNS400ZInsurance";
import BajajDominar400Insurance from "./components/BajajBrandBikeInsurancePages/BajajDominar400Insurance";
import BajajPulsarN160Insurance from "./components/BajajBrandBikeInsurancePages/BajajPulsarN160Insurance";
import SuzukiAccess125Insurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiAccess125Insurance";
import SuzukiBurgmanStreet125Insurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiBurgmanStreet125Insurance";
import SuzukiGixxerInsurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiGixxerInsurance";
import SuzukiVStromSX250Insurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiVStromSX250Insurance";
import SuzukiVStrom800DEInsurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiVStrom800DEInsurance";
import SuzukiHayabusaInsurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiHayabusaInsurance";
import SuzukiAvenis125Insurance from "./components/SuzukiBikeInsuranceBrandPages/SuzukiAvenis125Insurance";
import YamahaR15Insurance from "./components/YamahaBikeInsuranceBrandPages/YamahaR15Insurance";
import YamahaMT15V2Insurance from "./components/YamahaBikeInsuranceBrandPages/YamahaMT15V2Insurance";
import YamahaFZSFIInsurance from "./components/YamahaBikeInsuranceBrandPages/YamahaFZSFIInsurance";
import RoyalEnfieldHunter350Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldHunter350Insurance";
import RoyalEnfieldClassic350Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldClassic350Insurance";
import RoyalEnfieldMeteor350Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldMeteor350Insurance";
import RoyalEnfieldBullet350Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldBullet350Insurance";
import RoyalEnfieldScram411Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldScram411Insurance";
import RoyalEnfieldHimalayan411Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldHimalayan411Insurance";
import RoyalEnfieldInterceptor650Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldInterceptor650Insurance";
import RoyalEnfieldContinentalGT650Insurance from "./components/RoyalEnfiledBrandInsurancePages/RoyalEnfieldContinentalGT650Insurance";
import Ather450XInsurance from "./components/AtherBikeInsuranceBrandPages/Ather450XInsurance";
import OlaS1XInsurance from "./components/OlaBikeInsuranceBrandPages/OlaS1XInsurance";
import OlaS1XPlusInsurance from "./components/OlaBikeInsuranceBrandPages/OlaS1XPlusInsurance";
import OlaS1ProInsurance from "./components/OlaBikeInsuranceBrandPages/OlaS1ProInsurance";
import OlaS1AirInsurance from "./components/OlaBikeInsuranceBrandPages/OlaS1AirInsurance";
import OlaRoadsterXInsurance from "./components/OlaBikeInsuranceBrandPages/OlaRoadsterXInsurance";
import OlaS1ProSportInsurance from "./components/OlaBikeInsuranceBrandPages/OlaS1ProSportInsurance";
import RevoltRV400Insurance from "./components/RevoltBikeInsuranceBrandPages/RevoltRV400Insurance";
import RevoltRV1Insurance from "./components/RevoltBikeInsuranceBrandPages/RevoltRV1Insurance";
import RevoltRVBlazeXInsurance from "./components/RevoltBikeInsuranceBrandPages/RevoltRVBlazeXInsurance";
import RevoltRV400BRZInsurance from "./components/RevoltBikeInsuranceBrandPages/RevoltRV400BRZInsurance";
import KTM125DukeInsurance from "./components/KtmbikeInsuranceBrandPage/KTM125DukeInsurance";
import KTM200DukeInsurance from "./components/KtmbikeInsuranceBrandPage/KTM200DukeInsurance";
import AtherRiztaInsurance from "./components/AtherBikeInsuranceBrandPages/AtherRiztaInsurance";
import Ather450SInsurance from "./components/AtherBikeInsuranceBrandPages/Ather450SInsurance";
import KTM250DukeInsurance from "./components/KtmbikeInsuranceBrandPage/KTM250DukeInsurance";
import KTM390DukeInsurance from "./components/KtmbikeInsuranceBrandPage/KTM390DukeInsurance";
import KTMRC125Insurance from "./components/KtmbikeInsuranceBrandPage/KTMRC125Insurance";
import KTMRC200Insurance from "./components/KtmbikeInsuranceBrandPage/KTMRC200Insurance";
import KTMRC390Insurance from "./components/KtmbikeInsuranceBrandPage/KTMRC390Insurance";
import KTMAdventure390Insurance from "./components/KtmbikeInsuranceBrandPage/KTMAdventure390Insurance";
import BMWG310RInsurance from "./components/BmwBikeInsuranceBrandPages/BMWG310RInsurance";
import BMWG310GSInsurance from "./components/BmwBikeInsuranceBrandPages/BMWG310GSInsurance";
import BMWG310RRInsurance from "./components/BmwBikeInsuranceBrandPages/BMWG310RRInsurance";
import BMWF900RInsurance from "./components/BmwBikeInsuranceBrandPages/BMWF900RInsurance";
import BMWF900XRInsurance from "./components/BmwBikeInsuranceBrandPages/BMWF900XRInsurance";
import BMWR1250GSInsurance from "./components/BmwBikeInsuranceBrandPages/BMWR1250GSInsurance";
import BMWS1000RRInsurance from "./components/BmwBikeInsuranceBrandPages/BMWS1000RRInsurance";
import BMWM1000RRInsurance from "./components/BmwBikeInsuranceBrandPages/BMWM1000RRInsurance";
import HarleyDavidsonX440Insurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonX440Insurance";
import HarleyDavidsonNightsterInsurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonNightsterInsurance";
import HarleyDavidsonSportsterSInsurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonSportsterSInsurance";
import HarleyDavidsonFatBoy114Insurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonFatBoy114Insurance";
import HarleyDavidsonHeritageClassic114Insurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonHeritageClassic114Insurance";
import HarleyDavidsonStreetGlideInsurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonStreetGlideInsurance";
import HarleyDavidsonRoadGlideInsurance from "./components/HarleyDavidsonBikeInsuranceBrandPage/HarleyDavidsonRoadGlideInsurance";
import TriumphSpeedT4Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphSpeedT4Insurance";
import TriumphSpeed400Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphSpeed400Insurance";
import TriumphScrambler400XInsurance from "./components/TriumphBikeInsuranceBrandPages/TriumphScrambler400XInsurance";
import TriumphThruxton400Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphThruxton400Insurance";
import TriumphTrident660Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphTrident660Insurance";
import TriumphStreetTriple765Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphStreetTriple765Insurance";
import TriumphTiger900Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphTiger900Insurance";
import TriumphRocket3Insurance from "./components/TriumphBikeInsuranceBrandPages/TriumphRocket3Insurance";
import { Helmet } from "react-helmet";
import YamahaAerox155Insurance from "./components/YamahaBikeInsuranceBrandPages/YamahaAerox155Insurance";

function App() {
  // const usePageTracking = () => {
  //   const location = useLocation();

  //   useEffect(() => {
  //     if (window.gtag) {
  //       window.gtag('config', 'G-DCYD12PDV7', {
  //         page_path: location.pathname,
  //       });
  //     }
  //   }, [location]);
  // };

  //   usePageTracking();

  // Error Boundary Component
  class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
      return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
      console.error("App Error:", error, errorInfo);
    }

    render() {
      if (this.state.hasError) {
        return (
          <div style={{ padding: "20px", textAlign: "center" }}>
            <h2>Oops! Something went wrong.</h2>
            <p>Please refresh the page to continue.</p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Reload Page
            </button>
          </div>
        );
      }
      return this.props.children;
    }
  }

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
       {/* <Helmet>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>  */}
      <ErrorBoundary> 
        {/* <Box sx={{ background: '#000' }}> */}
        {/* <Navbar /> */}
        <NavBarNew />
        {/* <NavBar /> */}
        {/* <ScrollToHashElement/> */}
        <Layout>
          <LayoutScroll>
            <ContactModal />
            <Routes>
              <Route path="/" exact element={<Home />} />
               <Route
                path="/triumph-rocket-3-bike-insurance"
                element={<TriumphRocket3Insurance/>}
              />
               <Route
                path="/triumph-tiger-900-bike-insurance"
                element={<TriumphTiger900Insurance/>}
              />
               <Route
                path="/triumph-street-triple-765-bike-insurance"
                element={<TriumphStreetTriple765Insurance/>}
              />
              <Route
                path="/triumph-trident-660-bike-insurance"
                element={<TriumphTrident660Insurance/>}
              />
              <Route
                path="/triumph-thruxton-400-bike-insurance"
                element={<TriumphThruxton400Insurance/>}
              />
              <Route
                path="/triumph-scrambler-400-x-bike-insurance"
                element={<TriumphScrambler400XInsurance/>}
              />
               <Route
                path="/triumph-speed-400-bike-insurance"
                element={<TriumphSpeed400Insurance/>}
              />
               <Route
                path="/triumph-speed-t4-bike-insurance"
                element={<TriumphSpeedT4Insurance/>}
              />
               <Route
                path="/harley-davidson-road-glide-bike-insurance"
                element={<HarleyDavidsonRoadGlideInsurance/>}
              />
               <Route
                path="/harley-davidson-street-glide-bike-insurance"
                element={<HarleyDavidsonStreetGlideInsurance/>}
              />
              <Route
                path="/harley-davidson-heritage-classic-114-bike-insurance"
                element={<HarleyDavidsonHeritageClassic114Insurance/>}
              />
                <Route
                path="/harley-davidson-fat-boy-114-bike-insurance"
                element={<HarleyDavidsonFatBoy114Insurance/>}
              />
               <Route
                path="/harley-davidson-sportster-s-bike-insurance"
                element={<HarleyDavidsonSportsterSInsurance/>}
              />
               <Route
                path="/harley-davidson-nightster-bike-insurance"
                element={<HarleyDavidsonNightsterInsurance/>}
              />
                <Route
                path="/harley-davidson-x440-bike-insurance"
                element={<HarleyDavidsonX440Insurance/>}
              />
               <Route
                path="/bmw-m1000-rr-bike-insurance"
                element={<BMWM1000RRInsurance/>}
              />
                <Route
                path="/bmw-s1000-rr-bike-insurance"
                element={<BMWS1000RRInsurance/>}
              />
               <Route
                path="/bmw-r1250-gs-bike-insurance"
                element={<BMWR1250GSInsurance/>}
              />
               <Route
                path="/bmw-f900-xr-bike-insurance"
                element={<BMWF900XRInsurance/>}
              />
               <Route
                path="/bmw-f900-r-bike-insurance"
                element={<BMWF900RInsurance/>}
              />
                <Route
                path="/bmw-g310-rr-bike-insurance"
                element={<BMWG310RRInsurance/>}
              />
                 <Route
                path="/bmw-g310-gs-bike-insurance"
                element={<BMWG310GSInsurance/>}
              />
                <Route
                path="/bmw-g310-r-bike-insurance"
                element={<BMWG310RInsurance/>}
              />
              <Route
                path="/ktm-adventure390-bike-insurance"
                element={<KTMAdventure390Insurance/>}
              />
                <Route
                path="/ktm-rc390-bike-insurance"
                element={<KTMRC390Insurance/>}
              />
                 <Route
                path="/ktm-rc200-bike-insurance"
                element={<KTMRC200Insurance/>}
              />
                <Route
                path="/ktm-rc125-bike-insurance"
                element={<KTMRC125Insurance/>}
              />
               <Route
                path="/ktm-390duke-bike-insurance"
                element={<KTM390DukeInsurance/>}
              />
              <Route
                path="/ktm-250duke-bike-insurance"
                element={<KTM250DukeInsurance/>}
              />
               <Route
                path="/ktm-200duke-bike-insurance"
                element={<KTM200DukeInsurance/>}
              />
                <Route
                path="/ktm-125duke-bike-insurance"
                element={<KTM125DukeInsurance/>}
              />
                <Route
                path="/revolt-rv400-brz-bike-insurance"
                element={<RevoltRV400BRZInsurance/>}
              />
                <Route
                path="/revolt-rv-blazex-bike-insurance"
                element={<RevoltRVBlazeXInsurance/>}
              />
                <Route
                path="/revolt-rv1-bike-insurance"
                element={<RevoltRV1Insurance/>}
              />
                <Route
                path="/revolt-rv400-bike-insurance"
                element={<RevoltRV400Insurance/>}
              />
              <Route
                path="/ola-s1-pro-sport-bike-insurance"
                element={<OlaS1ProSportInsurance/>}
              />
               <Route
                path="/ola-roadsterx-bike-insurance"
                element={<OlaRoadsterXInsurance/>}
              />
               <Route
                path="/ola-s1-air-bike-insurance"
                element={<OlaS1AirInsurance/>}
              />
                <Route
                path="/ola-s1pro-bike-insurance"
                element={<OlaS1ProInsurance/>}
              />
               <Route
                path="/ola-s1x-plus-bike-insurance"
                element={<OlaS1XPlusInsurance/>}
              />
                <Route
                path="/ola-s1x-bike-insurance"
                element={<OlaS1XInsurance/>}
              />
                <Route
                path="/ather-450s-bike-insurance"
                element={<Ather450SInsurance/>}
              />
               <Route
                path="/ather-rizta-bike-insurance"
                element={<AtherRiztaInsurance/>}
              />
                <Route
                path="/ather-450x-bike-insurance"
                element={<Ather450XInsurance/>}
              />
              <Route
                path="/royal-enfield-interceptor650-bike-insurance"
                element={<RoyalEnfieldInterceptor650Insurance/>}
              />
              <Route
                path="/royal-enfield-continental-gt650-bike-insurance"
                element={<RoyalEnfieldContinentalGT650Insurance/>}
              />
                 <Route
                path="/royal-enfield-himalayan411-bike-insurance"
                element={<RoyalEnfieldHimalayan411Insurance/>}
              />
                 <Route
                path="/royal-enfield-scram411-bike-insurance"
                element={<RoyalEnfieldScram411Insurance/>}
              />
                <Route
                path="/royal-enfield-bullet350-bike-insurance"
                element={<RoyalEnfieldBullet350Insurance/>}
              />
                <Route
                path="/royal-enfield-meteor350-bike-insurance"
                element={<RoyalEnfieldMeteor350Insurance/>}
              />
                <Route
                path="/royal-enfield-classic350-bike-insurance"
                element={<RoyalEnfieldClassic350Insurance/>}
              />
               <Route
                path="/royal-enfield-hunter350-bike-insurance"
                element={<RoyalEnfieldHunter350Insurance/>}
              />
              <Route
                path="/yamaha-aerox155-bike-insurance"
                element={<YamahaAerox155Insurance/>}
              />
               <Route
                path="/yamaha-fzs-bike-insurance"
                element={<YamahaFZSFIInsurance/>}
              />
                <Route
                path="/yamaha-mt15v2-bike-insurance"
                element={<YamahaMT15V2Insurance/>}
              />
               <Route
                path="/yamaha-r15-bike-insurance"
                element={<YamahaR15Insurance/>}
              />
               <Route
                path="/suzuki-avenis125-bike-insurance"
                element={<SuzukiAvenis125Insurance/>}
              />
               <Route
                path="/suzuki-hayabusa-bike-insurance"
                element={<SuzukiHayabusaInsurance/>}
              />
              <Route
                path="/suzuki-vstrom-800de-bike-insurance"
                element={<SuzukiVStrom800DEInsurance/>}
              />
               <Route
                path="/suzuki-vstrom-sx250-bike-insurance"
                element={<SuzukiVStromSX250Insurance/>}
              />
              <Route
                path="/suzuki-gixxer-bike-insurance"
                element={<SuzukiGixxerInsurance/>}
              />
               <Route
                path="/suzuki-burgman-street125-bike-insurance"
                element={<SuzukiBurgmanStreet125Insurance/>}
              />
               <Route
                path="/suzuki-access-125-bike-insurance"
                element={<SuzukiAccess125Insurance/>}
              />
               <Route
                path="/bajaj-pulsar-n160-bike-insurance"
                element={<BajajPulsarN160Insurance/>}
              />
              <Route
                path="/bajaj-dominar-400-bike-insurance"
                element={<BajajDominar400Insurance/>}
              />
               <Route
                path="/bajaj-pulsar-ns400-bike-insurance"
                element={<BajajPulsarNS400ZInsurance/>}
              />
                <Route
                path="/bajaj-chetak-bike-insurance"
                element={<BajajChetakInsurance/>}
              />
                <Route
                path="/bajaj-pulsar200-bike-insurance"
                element={<BajajPulsar200Insurance/>}
              />
              <Route
                path="/bajaj-platina-bike-insurance"
                element={<BajajPlatinaInsurance/>}
              />
               <Route
                path="/bajaj-pulsar125-bike-insurance"
                element={<BajajPulsar125Insurance/>}
              />
               <Route
                path="/tvs-radeon-bike-insurance"
                element={<TVSRadeonInsurance/>}
              />
              <Route
                path="/tvs-sport-bike-insurance"
                element={<TVSSportInsurance/>}
              />
               <Route
                path="/tvs-ntorq125-bike-insurance"
                element={<TVSNtorq125Insurance/>}
              />
               <Route
                path="/tvs-iqube-bike-insurance"
                element={<TVSiQubeInsurance/>}
              />
               <Route
                path="/tvs-apache-rtr1604v-bike-insurance"
                element={<TVSApacheRTR1604VInsurance/>}
              />
               <Route
                path="/tvs-raider125-bike-insurance"
                element={<TVSRaider125Insurance/>}
              />
               <Route
                path="/tvs-jupiter-bike-insurance"
                element={<TVSJupiterInsurance/>}
              />
               <Route
                path="/honda-cb750-hornet-bike-insurance"
                element={<HondaCB750HornetInsurance/>}
              />
               <Route
                path="/honda-cb350-hness-bike-insurance"
                element={<HondaCB350HnessInsurance/>}
              />
               <Route
                path="/honda-cb200X-bike-insurance"
                element={<HondaCB200XInsurance/>}
              />
                 <Route
                path="/honda-unicorn-bike-insurance"
                element={<HondaUnicornInsurance/>}
              />
               <Route
                path="/honda-sp-125-bike-insurance"
                element={<HondaSP125Insurance/>}
              />
               <Route
                path="/honda-shine-125-bike-insurance"
                element={<HondaShine125Insurance/>}
              />
               <Route
                path="/honda-activa-bike-insurance"
                element={<HondaActivaInsurance/>}
              />
              <Route
                path="/hero-xpulse-421-bike-insurance"
                element={<HeroXPulse421Insurance/>}
              />
               <Route
                path="/hero-karizma-xmr-250-bike-insurance"
                element={<HeroKarizmaXMR250Insurance/>}
              />
                <Route
                path="/hero-super-splendor-xtec-bike-insurance"
                element={<HeroSuperSplendorXTECInsurance/>}
              />
               <Route
                path="/hero-glamour-xtec-bike-insurance"
                element={<HeroGlamourXTECInsurance/>}
              />
               <Route
                path="/hero-xtreame-125-bike-insurance"
                element={<HeroXtreme125RInsurance/>}
              />
                <Route
                path="/hero-hf-deluxe-bike-insurance"
                element={<HeroHFDeluxeInsurance/>}
              />
               <Route
                path="/hero-splendor-plus-bike-insurance"
                element={<HeroSplendorPlusInsurance/>}
              />
              <Route
                path="/porsche-718-car-insurance"
                element={<Porsche718Insurance/>}
              />
                <Route
                path="/porsche-taycan-car-insurance"
                element={<PorscheTaycanInsurance/>}
              />
               <Route
                path="/porsche-911-car-insurance"
                element={<Porsche911Insurance/>}
              />
              <Route
                path="/porsche-panamera-car-insurance"
                element={<PorschePanameraInsurance/>}
              />
               <Route
                path="/porsche-cayennecoupe-car-insurance"
                element={<PorscheCayenneCoupeInsurance/>}
              />
                <Route
                path="/porsche-cayenne-car-insurance"
                element={<PorscheCayenneInsurance/>}
              />
               <Route
                path="/porsche-macan-car-insurance"
                element={<PorscheMacanInsurance/>}
              />
              <Route
                path="/jaguar-xf-car-insurance"
                element={<JaguarXFInsurance/>}
              />
               <Route
                path="/jaguar-ftype-car-insurance"
                element={<JaguarFTypeInsurance/>}
              />
                 <Route
                path="/jaguar-xe-car-insurance"
                element={<JaguarXEInsurance/>}
              />
               <Route
                path="/jaguar-ipace-car-insurance"
                element={<JaguarIPaceInsurance/>}
              />
               <Route
                path="/jaguar-fpace-car-insurance"
                element={<JaguarFPaceInsurance/>}
              />
               <Route
                path="/lexus-lc-car-insurance"
                element={<LexusLCInsurance/>}
              />
                <Route
                path="/lexus-lm-car-insurance"
                element={<LexusLMInsurance/>}
              />
               <Route
                path="/lexus-lx-car-insurance"
                element={<LexusLXInsurance/>}
              />
              <Route
                path="/lexus-rx-car-insurance"
                element={<LexusRXInsurance/>}
              />
                <Route
                path="/lexus-nx-car-insurance"
                element={<LexusNXInsurance/>}
              />
                <Route
                path="/lexus-es-car-insurance"
                element={<LexusESInsurance/>}
              />
                <Route
                path="/volvo-s90-car-insurance"
                element={<VolvoS90Insurance/>}
              />
                <Route
                path="/volvo-xc40-car-insurance"
                element={<VolvoXC40RechargeInsurance/>}
              />
                <Route
                path="/volvo-c40-car-insurance"
                element={<VolvoC40RechargeInsurance/>}
              />
               <Route
                path="/volvo-xc90-car-insurance"
                element={<VolvoXC90Insurance/>}
              />
               <Route
                path="/volvo-xc60-car-insurance"
                element={<VolvoXC60Insurance/>}
              />
                <Route
                path="/audi-etron-car-insurance"
                element={<AudiEtronInsurance/>}
              />
               <Route
                path="/audi-q8-car-insurance"
                element={<AudiQ8Insurance/>}
              />
              <Route
                path="/audi-q7-car-insurance"
                element={<AudiQ7Insurance/>}
              />
               <Route
                path="/audi-q5-car-insurance"
                element={<AudiQ5Insurance/>}
              />
                 <Route
                path="/audi-q3-car-insurance"
                element={<AudiQ3Insurance/>}
              />
                <Route
                path="/audi-a8l-car-insurance"
                element={<AudiA8LInsurance />}
              />
               <Route
                path="/audi-a6-car-insurance"
                element={<AudiA6Insurance />}
              />
              <Route
                path="/audi-a4-car-insurance"
                element={<AudiA4Insurance />}
              />
               <Route
                path="/bmw-z4-car-insurance"
                element={<BMWZ4Insurance />}
              />
              <Route
                path="/bmw-ix-car-insurance"
                element={<BMWiXInsurance />}
              />
               <Route
                path="/bmw-x5-car-insurance"
                element={<BMWX5Insurance/>}
              />
               <Route
                path="/bmw-x3-car-insurance"
                element={<BMWX3Insurance/>}
              />
               <Route
                path="/bmw-7series-car-insurance"
                element={<BMW7SeriesInsurance/>}
              />
                <Route
                path="/bmw-5series-car-insurance"
                element={<BMW5SeriesInsurance/>}
              />
               <Route
                path="/bmw-3series-car-insurance"
                element={<BMW3SeriesInsurance />}
              />
               <Route
                path="/bmw-x1-car-insurance"
                element={<BMWX1Insurance />}
              />
               <Route
                path="/mercedes-benz-sclass-car-insurance"
                element={<MercedesBenzSClassInsurance />}
              />
              <Route
                path="/mercedes-benz-eclass-car-insurance"
                element={<MercedesBenzEClassInsurance />}
              />
              <Route
                path="/mercedes-benz-cclass-car-insurance"
                element={<MercedesBenzCClassInsurance />}
              />
              <Route
                path="/mercedes-benz-aclass-limousine-car-insurance"
                element={<MercedesBenzAClassLimousineInsurance />}
              />
              <Route
                path="/mercedes-benz-gls-car-insurance"
                element={<MercedesBenzGLSInsurance />}
              />
               <Route
                path="/mercedes-benz-gle-car-insurance"
                element={<MercedesBenzGLEInsurance />}
              />
               <Route
                path="/mercedes-benz-glc-car-insurance"
                element={<MercedesBenzGLCInsurance />}
              />
              <Route
                path="/mercedes-benz-gla-car-insurance"
                element={<MercedesBenzGLAInsurance />}
              />
               <Route
                path="/volkswagen-id4-car-insurance"
                element={<VolkswagenID4Insurance />}
              />
                <Route
                path="/volkswagen-polo-car-insurance"
                element={<VolkswagenPoloInsurance />}
              />
                <Route
                path="/volkswagen-tiguan-car-insurance"
                element={<VolkswagenTiguanInsurance />}
              />
                 <Route
                path="/volkswagen-golfgt-car-insurance"
                element={<VolkswagenGolfGTIInsurance />}
              />
                 <Route
                path="/volkswagen-taigun-car-insurance"
                element={<VolkswagenTaigunInsurance />}
              />
               <Route
                path="/volkswagen-virtus-car-insurance"
                element={<VolkswagenVirtusInsurance />}
              />
                 <Route
                path="/renault-duster-car-insurance"
                element={<RenaultDusterInsurance />}
              />
                 <Route
                path="/renault-triber-car-insurance"
                element={<RenaultTriberInsurance />}
              />
                <Route
                path="/renault-kiger-car-insurance"
                element={<RenaultKigerInsurance />}
              />
                <Route
                path="/renault-kwid-car-insurance"
                element={<RenaultKwidInsurance />}
              />
               <Route
                path="/honda-crv-car-insurance"
                element={<HondaCRVInsurance />}
              />
               <Route
                path="/honda-accord-hybrid-car-insurance"
                element={<HondaAccordHybridInsurance />}
              />
               <Route
                path="/honda-city-hybrid-car-insurance"
                element={<HondaCityHybridInsurance />}
              />
               <Route
                path="/honda-jazz-car-insurance"
                element={<HondaJazzInsurance />}
              />
              <Route
                path="/honda-wrv-car-insurance"
                element={<HondaWRVInsurance />}
              />
              <Route
                path="/honda-elevate-car-insurance"
                element={<HondaElevateInsurance />}
              />
              <Route
                path="/honda-amaze-car-insurance"
                element={<HondaAmazeInsurance />}
              />
                <Route
                path="/honda-city-car-insurance"
                element={<HondaCityInsurance />}
              />
                <Route
                path="/mg-marvelx-car-insurance"
                element={<MGMarvelXInsurance />}
              />
                <Route
                path="/mg-rc6-car-insurance"
                element={<MGRC6Insurance/>}
              />
               <Route
                path="/mg-gloster-car-insurance"
                element={<MGGlosterInsurance/>}
              />
              <Route
                path="/mg-zsev-car-insurance"
                element={<MGZSEVInsurance/>}
              />
               <Route
                path="/mg-cometev-car-insurance"
                element={<MGCometEVInsurance/>}
              />
               <Route
                path="/mg-astor-car-insurance"
                element={<MGAstorInsurance/>}
              />
               <Route
                path="/mg-hector-plus-car-insurance"
                element={<MGHectorPlusInsurance/>}
              />
               <Route
                path="/mg-hector-car-insurance"
                element={<MGHectorInsurance/>}
              />
               <Route
                path="/skoda-octavia-car-insurance"
                element={<SkodaOctaviaInsurance/>}
              />
               <Route
                path="/skoda-fabia-car-insurance"
                element={<SkodaFabiaInsurance />}
              />
                 <Route
                path="/skoda-rapid-car-insurance"
                element={<SkodaRapidInsurance />}
              />
                <Route
                path="/skoda-superb-car-insurance"
                element={<SkodaSuperbInsurance />}
              />
               <Route
                path="/skoda-kodiaq-car-insurance"
                element={<SkodaKodiaqInsurance />}
              />
              <Route
                path="/skoda-kushaq-car-insurance"
                element={<SkodaKushaqInsurance />}
              />
               <Route
                path="/skoda-slavia-car-insurance"
                element={<SkodaSlaviaInsurance/>}
              />
              <Route
                path="/skoda-laura-car-insurance"
                element={<SkodaLauraInsurance/>}
              />
              <Route
                path="/nissan-sunny-car-insurance"
                element={<NissanSunnyInsurance/>}
              />
              <Route
                path="/nissan-gtr-car-insurance"
                element={<NissanGTRInsurance/>}
              />
                <Route
                path="/nissan-kicks-car-insurance"
                element={<NissanKicksInsurance/>}
              />
                 <Route
                path="/nissan-magnite-car-insurance"
                element={<NissanMagniteInsurance/>}
              />
                <Route
                path="/toyota-fortuner-car-insurance"
                element={<ToyotaFortunerInsurance />}
              />
               <Route
                path="/toyota-vellfire-car-insurance"
                element={<ToyotaVellfireInsurance />}
              />
               <Route
                path="/toyota-camry-car-insurance"
                element={<ToyotaCamryInsurance />}
              />
               <Route
                path="/toyota-hilux-car-insurance"
                element={<ToyotaHiluxInsurance />}
              />
               <Route
                path="/toyota-glanza-car-insurance"
                element={<ToyotaGlanzaInsurance />}
              />
               <Route
                path="/toyota-urban-cruiser-hyryder-car-insurance"
                element={<ToyotaUrbanCruiserHyryderInsurance />}
              />
              <Route
                path="/toyota-innova-hycross-car-insurance"
                element={<ToyotaInnovaHycrossInsurance />}
              />
               <Route
                path="/toyota-innova-crysta-car-insurance"
                element={<ToyotaInnovaCrystaInsurance />}
              />
               <Route
                path="/kia-rio-car-insurance"
                element={<KiaRioInsurance />}
              />
               <Route
                path="/kia-sportage-car-insurance"
                element={<KiaSportageInsurance />}
              />
               <Route
                path="/kia-carnival-car-insurance"
                element={<KiaCarnivalInsurance />}
              />
               <Route
                path="/kia-ev9-car-insurance"
                element={<KiaEV9Insurance />}
              />
              <Route
                path="/kia-ev6-car-insurance"
                element={<KiaEV6Insurance />}
              />

              <Route
                path="/kia-carens-car-insurance"
                element={<KiaCarensInsurance />}
              />

              <Route
                path="/kia-sonet-car-insurance"
                element={<KiaSonetInsurance />}
              />
              <Route
                path="/kia-seltos-car-insurance"
                element={<KiaSeltosInsurance />}
              />

              <Route
                path="/mahindra-xuv400-car-insurance"
                element={<MahindraXUV400Insurance />}
              />
              <Route
                path="/mahindra-marazzo-car-insurance"
                element={<MahindraMarazzoInsurance />}
              />
              <Route
                path="/mahindra-bolero-car-insurance"
                element={<MahindraBoleroInsurance />}
              />

              <Route
                path="/mahindra-xuv300-car-insurance"
                element={<MahindraXUV300Insurance />}
              />
              <Route
                path="/mahindra-baleroneo-car-insurance"
                element={<MahindraBoleroNeoInsurance />}
              />

              <Route
                path="/mahindra-thar-car-insurance"
                element={<MahindraTharInsurance />}
              />

              <Route
                path="/mahindra-xuv700-car-insurance"
                element={<MahindraXUV700Insurance />}
              />

              <Route
                path="/mahindra-scorpion-car-insurance"
                element={<MahindraScorpioNInsurance />}
              />

              <Route
                path="/tata-curvv-car-insurance"
                element={<TataCurvvInsurance />}
              />

              <Route
                path="/tata-tigor-car-insurance"
                element={<TataTigorInsurance />}
              />
              <Route
                path="/tata-tiago-car-insurance"
                element={<TataTiagoInsurance />}
              />

              <Route
                path="/tata-altroz-car-insurance"
                element={<TataAltrozInsurance />}
              />

              <Route
                path="/tata-safari-car-insurance"
                element={<TataSafariInsurance />}
              />

              <Route
                path="/tata-harrier-car-insurance"
                element={<TataHarrierInsurance />}
              />

              <Route
                path="/tata-punch-car-insurance"
                element={<TataPunchInsurance />}
              />

              <Route
                path="/tata-nexon-car-insurance"
                element={<TataNexonInsurance />}
              />

              <Route
                path="/hyundai-tucson-car-insurance"
                element={<HyundaiTucsonInsurance />}
              />

              <Route
                path="/hyundai-alcazar-car-insurance"
                element={<HyundaiAlcazarInsurance />}
              />

              <Route
                path="/hyundai-verna-car-insurance"
                element={<HyundaiVernaInsurance />}
              />

              <Route
                path="/hyundai-grand-i10nios-car-insurance"
                element={<HyundaiGrandI10NiosInsurance />}
              />

              <Route
                path="/hyundai-i20-car-insurance"
                element={<HyundaiI20Insurance />}
              />

              <Route
                path="/hyundai-exter-car-insurance"
                element={<HyundaiExterInsurance />}
              />

              <Route
                path="/hyundai-venue-car-insurance"
                element={<HyundaiVenueInsurance />}
              />

              <Route
                path="/hyundai-creata-car-insurance"
                element={<HyundaiCretaInsurance />}
              />

              <Route
                path="/maruti-suzuki-fronx-car-insurance"
                element={<MarutiSuzukiFronxInsurance />}
              />

              <Route
                path="/maruti-suzuki-brezza-car-insurance"
                element={<MarutiSuzukiBrezzaInsurance />}
              />

              <Route
                path="/maruti-suzuki-ertiga-car-insurance"
                element={<MarutiSuzukiErtigaInsurance />}
              />

              <Route
                path="/maruti-suzuki-dzire-car-insurance"
                element={<MarutiSuzukiDzireInsurance />}
              />

              <Route
                path="/maruti-suzuki-baleno-car-insurance"
                element={<MarutiSuzukiBalenoInsurance />}
              />

              <Route
                path="/maruti-suzuki-swift-car-insurance"
                element={<MarutiSuzukiSwiftInsurance />}
              />

              <Route
                path="/maruti-suzuki-wagonr-car-insurance"
                element={<MarutiSuzukiWagonRInsurance />}
              />

              <Route
                path="/maruti-suzuki-alto-car-insurance"
                element={<MarutiSuzukiAltoCarInsurance />}
              />

              <Route
                path="/triump-two-wheeler-loan"
                element={<TriumphTwoWheelerLoan />}
              />

              <Route
                path="/harley-davidson-two-wheeler-loan"
                element={<HarleyDavidsonTwoWheelerLoan />}
              />

              <Route
                path="/bmw-two-wheeler-loan"
                element={<BmwMotorradTwoWheelerLoan />}
              />

              <Route
                path="/ktm-two-wheeler-loan"
                element={<KtmTwoWheelerLoan />}
              />

              <Route
                path="/revolt-two-wheeler-loan"
                element={<RevoltTwoWheelerLoan />}
              />

              <Route
                path="/ola-two-wheeler-loan"
                element={<OlaTwoWheelerLoan />}
              />

              <Route
                path="/ather-two-wheeler-loan"
                element={<AtherTwoWheelerLoan />}
              />

              <Route
                path="/royal-enfield-two-wheeler-loan"
                element={<RoyalEnfieldTwoWheelerLoan />}
              />

              <Route
                path="/yamaha-two-wheeler-loan"
                element={<YamahaTwoWheelerLoan />}
              />

              <Route
                path="/suzuki-two-wheeler-loan"
                element={<SuzukiTwoWheelerLoan />}
              />

              <Route
                path="/bajaj-two-wheeler-loan"
                element={<BajajTwoWheelerLoan />}
              />

              <Route
                path="/tvs-two-wheeler-loan"
                element={<TVSTwoWheelerLoan />}
              />

              <Route
                path="/honda-two-wheeler-loan"
                element={<HondaTwoWheelerLoan />}
              />

              <Route
                path="/hero-moto-corp-two-wheeler-loan"
                element={<HeroMotoCorpTwoWheelerLoan />}
              />

              <Route path="/porsche-car-loan" element={<PorscheCarLoan />} />

              <Route path="/jaguar-car-loan" element={<JaguarCarLoan />} />

              <Route path="/lexus-car-loan" element={<LexusCarLoan />} />

              <Route path="/volvo-car-loan" element={<VolvoCarLoan />} />

              <Route path="/audi-car-loan" element={<AudiCarLoan />} />

              <Route path="/bmw-car-loan" element={<BMWCarLoan />} />

              <Route
                path="/mercedes-car-loan"
                element={<MercedesBenzCarLoan />}
              />

              <Route
                path="/volkswagen-car-loan"
                element={<VolkswagenCarLoan />}
              />

              <Route path="/honda-car-loan" element={<HondaCarLoan />} />
              <Route path="/renault-car-loan" element={<RenaultCarLoan />} />

              <Route path="/mg-car-loan" element={<MgCarLoan />} />

              <Route path="/skoda-car-loan" element={<SkodaCarLoan />} />

              <Route path="/kia-car-loan" element={<KiaCarLoan />} />
              <Route path="/nissan-car-loan" element={<NissanCarLoan />} />

              <Route path="/toyota-car-loan" element={<ToyotaCarLoan />} />

              <Route
                path="/tata-motors-car-loan"
                element={<TataMotorsCarLoan />}
              />
              <Route path="/hyundai-car-loan" element={<HyundaiCarLoan />} />
              <Route path="/mahindra-car-loan" element={<MahindraCarLoan />} />

              <Route
                path="/maruti-suzuki-car-loan"
                element={<MarutiSuzukiCarLoan />}
              />

              <Route
                path="/triumph-two-wheeler-insurance"
                element={<TriumphBikeInsurance />}
              />

              <Route
                path="/harley-davidson-two-wheeler-insurance"
                element={<HarleyDavidsonBikeInsurance />}
              />

              <Route
                path="/bmw-two-wheeler-insurance"
                element={<BMWMotorradInsurance />}
              />

              <Route
                path="/ktm-two-wheeler-insurance"
                element={<KTMBikeInsurance />}
              />

              <Route
                path="/revolt-electric-two-wheeler-insurance"
                element={<RevoltElectricBikeInsurance />}
              />

              <Route
                path="/ola-electric-two-wheeler-insurance"
                element={<OlaElectricScooterInsurance />}
              />

              <Route
                path="/ather-electrics-two-wheeler-insurance"
                element={<AtherElectricScooterInsurance />}
              />

              <Route
                path="/royal-enfield-two-wheeler-insurance"
                element={<RoyalEnfieldTwoWheelerInsurance />}
              />

              <Route
                path="/yamaha-two-wheeler-insurance"
                element={<YamahaTwoWheelerInsurance />}
              />

              <Route
                path="/suzuki-two-wheeler-insurance"
                element={<SuzukiTwoWheelerInsurance />}
              />

              <Route
                path="/bajaj-two-wheeler-insurance"
                element={<BajajTwoWheelerInsurance />}
              />

              <Route
                path="/tvs-two-wheeler-insurance"
                element={<TVSTwoWheelerInsurance />}
              />

              <Route
                path="/honda-two-wheeler-insurance"
                element={<HondaTwoWheelerInsurance />}
              />

              <Route
                path="/hero-moto-corp-two-wheeler-insurance"
                element={<HeroMotoCorpTwoWheelerInsurance />}
              />

              <Route
                path="/porsche-car-insurance"
                element={<PorscheCarInsurance />}
              />

              <Route
                path="/jaguar-land-rover-car-insurance"
                element={<JaguarLandRoverCarInsurance />}
              />

              <Route
                path="/lexus-car-insurance"
                element={<LexusCarInsurance />}
              />

              <Route
                path="/volvo-car-insurance"
                element={<VolvoCarInsurance />}
              />

              <Route
                path="/audi-car-insurance"
                element={<AudiCarInsurance />}
              />

              <Route path="/bmw-car-insurance" element={<BMWCarInsurance />} />

              <Route
                path="/mercedes-benz-car-insurance"
                element={<MercedesBenzCarInsurance />}
              />

              <Route
                path="/volkswagen-car-insurance"
                element={<VolkswagenCarInsurance />}
              />

              <Route
                path="/renault-car-insurance"
                element={<RenaultCarInsurance />}
              />

              <Route
                path="/honda-car-insurance"
                element={<HondaCarInsurance />}
              />

              <Route path="/mg-car-insurance" element={<MGCarInsurance />} />

              <Route
                path="/skoda-car-insurance"
                element={<SkodaCarInsurance />}
              />

              <Route
                path="/nissan-car-insurance"
                element={<NissanCarInsurance />}
              />

              <Route
                path="/toyota-car-insurance"
                element={<ToyotaCarInsurance />}
              />

              <Route path="/kia-car-insurance" element={<KiaCarInsurance />} />

              <Route
                path="/mahindra-car-insurance"
                element={<MahindraCarInsurance />}
              />

              <Route
                path="/tata-car-insurance"
                element={<TataCarInsurance />}
              />

              <Route
                path="/hyundai-car-insurance"
                element={<HyundaiCarInsurance />}
              />

              <Route
                path="/maruti-suzuki-car-insurance"
                element={<MarutiSuzukiCarInsurance />}
              />

              <Route path="/blog" element={<Blogs />} />
              <Route path="/blog/:id" element={<SingleBlogNew />} />

              <Route path="/loan" element={<LoanInsuranceNewUiHome />} />

              <Route path="/business-loan" element={<BusinessLoanNew />} />
              <Route
                path="/business-loan/:pageUrl"
                element={<BusinessLoanDetail />}
              />

              <Route path="/gold-loan" element={<GoldLoanNew />} />
              <Route path="/gold-loan/:pageUrl" element={<GoldLoanDetail />} />

              <Route path="/two-wheeler-loan" element={<TwoWheelerLoanNew />} />
              <Route
                path="/two-wheeler-loan/:pageUrl"
                element={<TwoWheelerLoanDetail />}
              />

              <Route path="/education-loan" element={<EducationLoanNew />} />
              <Route
                path="/education-loan/:pageUrl"
                element={<EducationLoanDetail />}
              />

              <Route path="/personal-loan" element={<PersonalLoanNew />} />
              <Route
                path="/personal-loan/:pageUrl"
                element={<PersonalLoanDetail />}
              />

              <Route path="/home-loan" element={<HomeLoanNew />} />
              <Route path="/home-loan/:pageUrl" element={<HomeLoanDetail />} />

              <Route path="/car-loan" element={<CarLoanNew />} />
              <Route path="/car-loan/:pageUrl" element={<CarLoanDetail />} />
              <Route path="/insurance" element={<InsuranceNewUiHome />} />

              <Route
                path="/termlife-insurance"
                element={<TermLifeInsuranceNew />}
              />
              <Route
                path="/termlife-insurance/:pageUrl"
                element={<TermInsuranceDetail />}
              />

              <Route
                path="/health-insurance"
                element={<HealthInsuranceNew />}
              />
              <Route
                path="/health-insurance/:pageUrl"
                element={<HealthInsuranceDetail />}
              />

              <Route
                path="/travel-insurance"
                element={<TravelInsuranceNew />}
              />
              <Route
                path="/travel-insurance/:pageUrl"
                element={<TravelInsuranceDetail />}
              />

              <Route path="/bike-insurance" element={<BikeInsuranceNew />} />
              <Route
                path="/bike-insurance/:pageUrl"
                element={<BikeInsuranceDetail />}
              />

              <Route path="/car-insurance" element={<CarInsuranceNew />} />
              <Route
                path="/car-insurance/:pageUrl"
                element={<CarInsuranceDetail />}
              />

              {/* <Route path="/insurance_page" element={<InsuranceMainPage />} />
              <Route
                path="/Insurance_page/:id"
                element={<SingleInsurancePage />}
              /> */}

              <Route path="/demat" element={<DematMainPage />} />
              <Route path="/demat/:id" element={<SingleDematPage />} />

              {/* <Route path="/loan_page/:id" element={<SingleLoanPage />} />
              <Route path="/loan_page" element={<LoanMainPage />} /> */}

              {/* <Route path='/blog_page/:id' element={<SinglepageBlog />} /> */}
              {/* <Route path='/blog_page' element={<Blogs />} /> */}
              {/* <Route path='/blog_page' element={<Navigate to="/blogpage" replace /> }/> */}

              <Route path="/sitemap" element={<SiteMapUi />} />
              <Route
                path="/financial-tools-calculators/canara-business-loan-emi-calculator"
                element={<CanaraBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/union-bank-of-india-business-loan-emi-calculator"
                element={<UnionBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/idfc-business-loan-emi-calculator"
                element={<IdfcBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/pnb-business-loan-emi-calculator"
                element={<PnbBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/kotak-business-loan-emi-calculator"
                element={<KotakBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/bank-of-baroda-business-loan-emi-calculator"
                element={<BobBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/axis-business-loan-emi-calculator"
                element={<AxisBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/icici-business-loan-emi-calculator"
                element={<IciciBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-business-loan-emi-calculator"
                element={<HdfcBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/sbi-business-loan-emi-calculator"
                element={<SbiBusinessLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/federal-education-loan-emi-calculator"
                element={<FederalEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/idfc-education-loan-emi-calculator"
                element={<IdfcEducationLoanEmiCalcu />}
              />
              <Route
                path="/financial-tools-calculators/canara-education-loan-emi-calculator"
                element={<CanaraEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/kotak-education-loan-emi-calculator"
                element={<KotakEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/bank-of-baroda-education-loan-emi-calculator"
                element={<BobEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/pnb-education-loan-emi-calculator"
                element={<PnbEducationLoanEMiCal />}
              />
              <Route
                path="/financial-tools-calculators/axis-education-loan-emi-calculator"
                element={<AxisEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/icici-education-loan-emi-calculator"
                element={<IciciEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-education-loan-emi-calculator"
                element={<HdfcEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/sbi-education-loan-emi-calculator"
                element={<SbiEducationLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/bank-of-baroda-gold-loan-emi-calculator"
                element={<BobGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/canara-gold-loan-emi-calculator"
                element={<CaneraBankGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/axis-gold-loan-emi-calculator"
                element={<AxisGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/icici-gold-loan-emi-calculator"
                element={<IciciGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/indian-bank-gold-loan-emi-calculator"
                element={<IndianBankGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/central-bank-of-india-gold-loan-emi-calculator"
                element={<CentralBOIGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/muthoot-finance-gold-loan-emi-calculator"
                element={<MutootFinanceGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/kotak-gold-loan-emi-calculator"
                element={<KotakGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-gold-loan-emi-calculator"
                element={<HdfcGoldLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/sbi-gold-loan-emi-calculator"
                element={<SbiGoldLoanEmiCalcu />}
              />
              <Route
                path="/financial-tools-calculators/standard-chartered-personal-loan-emi-calculator"
                element={<StandardCharteredPersonalEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/citi-personal-loan-emi-calculator"
                element={<CitiPersonalLoanEmiCalc />}
              />
              <Route
                path="/financial-tools-calculators/idfc-personal-loan-emi-calculator"
                element={<IdfcPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/federal-bank-personal-loan-emi-calculator"
                element={<FederalPersonalLoanEMiCal />}
              />
              <Route
                path="/financial-tools-calculators/yes-bank-personal-loan-emi-calculator"
                element={<YesBankPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/indusind-personal-loan-emi-calculator"
                element={<IndusindPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/kotak-personal-loan-emi-calculator"
                element={<KotakPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/icici-personal-loan-emi-calculator"
                element={<IciciPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/axis-personal-loan-emi-calculator"
                element={<AxisPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-personal-loan-emi-calculator"
                element={<HdfcPersonalLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/pnb-home-loan-emi-calculator"
                element={<PnbHomeLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/iob-home-loan-emi-calculator"
                element={<IobHomeLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/union-home-loan-emi-calculator"
                element={<UBIHomeLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/canara-home-loan-emi-calculator"
                element={<CanaraHomeLoanEmiCal />}
              />
              <Route
                path="/financial-tools-calculators/bob-home-loan-emi-calculator"
                element={<BobHomeLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/lic-housing-finance-home-loan-emi-calculator"
                element={<LicHousingFinanceHomeLoan />}
              />
              <Route
                path="/financial-tools-calculators/axis-home-loan-emi-calculator"
                element={<AxisHomeLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/icici-home-loan-emi-calculator"
                element={<IciciHomeLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-home-loan-emi-calculator"
                element={<HdfcHomeLoanEMiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/sbi-home-loan-emi-calculator"
                element={<SbihomeLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/muthoot-finance-bank-bike-loan-emi-calculator"
                element={<MuthootFinanceBikeLoanEmi />}
              />
              <Route
                path="/financial-tools-calculators/mahindra-finance-bank-bike-loan-emi-calculator"
                element={<MahindraFinanceBikeEmi />}
              />
              <Route
                path="/financial-tools-calculators/tata-capital-bank-bike-loan-emi-calculator"
                element={<TataCapitalBikeEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/kotak-mahindra-bank-bike-loan-emi-calculator"
                element={<KotakMahindraBikeEMiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/bajaj-finserv-bank-bike-loan-emi-calculator"
                element={<BajajFinserveBikeloanEmi />}
              />
              <Route
                path="/financial-tools-calculators/axis-bank-bike-loan-emi-calculator"
                element={<AxixBankBikeloanEmi />}
              />
              <Route
                path="/financial-tools-calculators/icici-bank-bike-loan-emi-calculator"
                element={<IciciBankBikeLoanEmi />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-bank-bike-loan-emi-calculator"
                element={<HdfcBikeLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/sbi-bank-bike-loan-emi-calculator"
                element={<SbiBikeLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/dhanlaxmi-bank-car-loan-emi-calculator"
                element={<DhanlaxmiCarloanEMiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/bank-of-maharashtra-car-loan-emi-calculator"
                element={<BomCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/bank-of-baroda-car-loan-emi-calculator"
                element={<BobCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/Union-car-loan-emi-calculator"
                element={<UninonBankCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/pnb-car-loan-emi-calculator"
                element={<PnbCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/canara-car-loan-emi-calculator"
                element={<CanaraCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-car-loan-emi-calculator"
                element={<HdfcCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/icici-car-loan-emi-calculator"
                element={<IciciCarloanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/axis-car-loan-emi-calculator"
                element={<AxixCarLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/sbi-car-loan-emi-calculator"
                element={<SbiLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/two-wheeler-loan-emi-calculator"
                element={<TwowheelerLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/education-loan-emi-calculator"
                element={<EducationLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/business-loan-emi-calculator"
                element={<BusinessLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/personal-loan-emi-calculator"
                element={<PersonalLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/gold-loan-emi-calculator"
                element={<GoldLoanEmiCalculator />}
              />
              <Route
                path="/financial-tools-calculators/idbi-bank-sip-calculator"
                element={<IDBISipCalculator />}
              />

              <Route
                path="/financial-tools-calculators/pnb-bank-sip-calculator"
                element={<PnbSipCalculator />}
              />

              <Route
                path="/financial-tools-calculators/lic-bank-sip-calculator"
                element={<LicSipCalculator />}
              />

              <Route
                path="/financial-tools-calculators/nippon-bank-sip-calculator"
                element={<NipponSipCalculator />}
              />

              <Route
                path="/financial-tools-calculators/sbi-bank-sip-calculator"
                element={<SbiSipCalculator />}
              />

              <Route
                path="/financial-tools-calculators/canara-bank-sip-calculator"
                element={<CanaraBankCalculator />}
              />

              <Route
                path="/financial-tools-calculators/axis-sip-calculator"
                element={<AxixSipCalculator />}
              />
              <Route
                path="/financial-tools-calculators/kotak-sip-calculator"
                element={<KotakSipCalculator />}
              />
              <Route
                path="/financial-tools-calculators/hdfc-sip-calculator"
                element={<HdfcSipCalculator />}
              />
              <Route
                path="/financial-tools-calculators/icici-sip-calculator"
                element={<IciciSipCalculator />}
              />
              <Route
                path="/financial-tools-calculators/health-insurance-calculator"
                element={<HealthInsuranceCalculator />}
              />

              <Route
                path="/financial-tools-calculators/bike-insurance-calculator"
                element={<BikeInsuranceCalculator />}
              />

              <Route
                path="/financial-tools-calculators/car-insurance-calculator"
                element={<CarInsuranceCalculator />}
              />

              <Route
                path="/financial-tools-calculators/travel-insurance-calculator"
                element={<TravelInsuranceCalculator />}
              />

              <Route
                path="/financial-tools-calculators/term-insurance-calculator"
                element={<TermLifeInsuranceCalculator />}
              />

              <Route
                path="/financial-tools-calculators/tds-calculator"
                element={<TDSCalculator />}
              />
              <Route
                path="/financial-tools-calculators/brokerage-calculator"
                element={<BrokerageCalculator />}
              />
              <Route
                path="/financial-tools-calculators/salary-calculator"
                element={<SalaryCalculator />}
              />
              <Route
                path="/financial-tools-calculators/inflation-calculator"
                element={<InflationCalculator />}
              />
              <Route
                path="/financial-tools-calculators/equity-margin-calculator"
                element={<EquityMarginCalculator />}
              />
              <Route
                path="/financial-tools-calculators/flat-vs-reducing-rate-calculator"
                element={<FlatReducingRateCalculator />}
              />
              <Route
                path="/financial-tools-calculators/gst-calculator"
                element={<GSTCalculator />}
              />
              <Route
                path="/financial-tools-calculators/cagr-calculator"
                element={<CAGRCalculator />}
              />
              <Route
                path="/financial-tools-calculators/apy-calculator"
                element={<APYCalculator />}
              />
              <Route
                path="/financial-tools-calculators/gratuity-calculator"
                element={<GratuityCalculator />}
              />
              <Route
                path="/financial-tools-calculators/car-loan-emi-calculator"
                element={<CarLoanEMICalculator />}
              />
              <Route
                path="/financial-tools-calculators/home-loan-emi-calculator"
                element={<HomeLoanEMICalculator />}
              />
              <Route
                path="/financial-tools-calculators/income-tax-calculator"
                element={<IncomeTaxCalculator />}
              />
              <Route
                path="/financial-tools-calculators/step-up-sip-calculator"
                element={<StepUpSIPCalculator />}
              />
              <Route
                path="/financial-tools-calculators/nsc-calculator"
                element={<NSCCalculator />}
              />
              <Route
                path="/financial-tools-calculators/compound-interest-calculator"
                element={<CompoundInterestCalculator />}
              />
              <Route
                path="/financial-tools-calculators/simple-interest-calculator"
                element={<SimpleInterestCalculator />}
              />
              <Route
                path="/financial-tools-calculators/emi-calculator"
                element={<EMICalculator />}
              />
              <Route
                path="/financial-tools-calculators/retirement-planning-calculator"
                element={<RetirementCalculator />}
              />
              <Route
                path="/financial-tools-calculators/hra-exemption-calculator"
                element={<HRACalculator />}
              />
              <Route
                path="/financial-tools-calculators/nps-calculator"
                element={<NPSCalculator />}
              />
              <Route
                path="/financial-tools-calculators/rd-calculator"
                element={<RDCalculator />}
              />
              <Route
                path="/financial-tools-calculators/fd-calculator"
                element={<FDCalculator />}
              />
              <Route
                path="/financial-tools-calculators/pf-epf-calculator"
                element={<EPFCalculator />}
              />
              <Route
                path="/financial-tools-calculators/ppf-calculator"
                element={<PPFCalculator />}
              />
              <Route
                path="/financial-tools-calculators/sukanya-samriddhi-yojana-calculator"
                element={<SSYCalculator />}
              />
              <Route
                path="/financial-tools-calculators/mutual-fund-calculator"
                element={<MutualFundCalculator />}
              />
              <Route
                path="/financial-tools-calculators/swp-calculator"
                element={<SWPCalculator />}
              />
              <Route
                path="/financial-tools-calculators"
                element={<ToolsPages />}
              />
              <Route
                path="/financial-tools-calculators/sip-calculator"
                element={<ToolOfSipLipPages />}
              />
              <Route
                path="/financial-tools-calculators/lumpsum-calculator"
                element={<ToolOfSipLipPages />}
              />

              {/* <Route path='/travel-insurance/hdfc-ergo-travel-insurance' element={<HdfcErgoTravelLearn />} />
        <Route path='/travel-insurance/care-health-travel-insurance' element={<CareHealthTravelLearn />} />
        <Route path='/travel-insurance/tata-aij-travel-insurance' element={<TataaijTravelLearn />} />
        <Route path='/travel-insurance/icici-lombard-travel-insurance' element={<IciciLombardTravelLearn />} />
        <Route path='/travel-insurance/bajaj-allianz-travel-insurance' element={<BajajTravelLearn />} /> */}
              {/* <Route path='/health-insurance/aditya-health-insurance' element={<AdityaHealthLearn />} />
        <Route path='/health-insurance/care-health-insurance' element={<CareHealthLearn />} />
        <Route path='/health-insurance/digit-health-insurance' element={<DigitHealthLearn />} />
        <Route path='/health-insurance/hdfc-ergo-health-insurance' element={<HdfcargoHealthLearn />} />
        <Route path='/health-insurance/reliance-health-insurance' element={<RelianceHealthLearn />} /> */}
              {/* <Route path='/life-insurance/adityalife-insurance' element={<AdityaLifeLearn />} />
        <Route path='/life-insurance/hdfc-life-insurance' element={<HdfcLifeLearn/>} />
        <Route path='/life-insurance/icici-life-insurance' element={<IciciLifeLearn />} />
        <Route path='/life-insurance/maxlife-insurance' element={<MaxLifeLearn />} /> */}
              {/* <Route path='/futurelife_insurance_learn_more' element={<FutureLifeLearn />} /> */}
              {/* <Route path='/bike-insurance/hdfc-bike-insurance' element={<HdfcBikeInsurance />} />
        <Route path='/bike-insurance/bajaj-bike-insurance' element={<BajajBikeInsurance />} />
        <Route path='/bike-insurance/acko-bike-insurance' element={<AckoBikeInsurance />} />
        <Route path='/bike-insurance/future-bike-insurance' element={<FutureBikeInsurance />} />
        <Route path='/bike-insurance/icici-bike-insurance' element={<IciciBikeInsurance />} />
        <Route path='/car-insurance/tata-aij-car-insurance' element={<TataAijLearnMore />} />
        <Route path='/car-insurance/hdfc-car-insurance' element={<HdfcCarLearnMore />} />
        <Route path='/car-insurance/acko-car-insurance' element={<AckoLearnMore />} />
        <Route path='/car-Insurance/icici-lombard-car-insurance' element={<IciciLombardLearn />} />
        <Route path='/car-insurance/bajaj-allianz-car-insurance' element={<BajajLearnMore />} /> */}
              {/* <Route
                path="/learn-more-page/card"
                element={<LearnMoreAllCards />}
              /> */}
  <Route path="/credit-card/:cardId" element={<LearnMoreAllCards />} />
              <Route
                path="/credit-card/aubank-credit-card"
                element={<AuBankLit />}
              />
              <Route
                path="/credit-card/eazy-diner-indusind-bank-credit-card"
                element={<EasyDinerBank />}
              />
              <Route
                path="/credit-card/hdfc-bank/millennia-credit-card"
                element={<HdfcBankMillennia />}
              />
              <Route
                path="/credit-card/sbi-simplyclick-credit-card"
                element={<SbiSimplyClick />}
              />
              <Route
                path="/credit-card/idfcfirst-classic-credit-card"
                element={<IdfcFirstClassic />}
              />
              <Route
                path="/credit-card/axis-bank-flipkart-credit-card"
                element={<FlipcartAxixBank />}
              />
              {/* <Route path='/car-loan' element={<CarLoan />} />
        <Route path='/home-loan' element={<HomeLoan />} />
        <Route path='/two-wheeler-loan' element={<TwoWheelerLoan />} />
        <Route path='/education-loan' element={<EducationLoan />} />
        <Route path='/personal-loan' element={<PersonalLoanU />} /> */}
              {/* <Route path='/learnmore_car_detail' element={<CarLoanLearnMore />} /> */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/term-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route
                path="/bank-of-india-bank/credit-card"
                element={<BoiBank />}
              />
              <Route path="/dbs-bank/credit-card" element={<DBS />} />
              <Route path="/indian-bank/credit-card" element={<IndianBank />} />
              <Route path="/equitas-bank/credit-card" element={<Equitas />} />
              <Route
                path="/ujjivan-bank/credit-card"
                element={<UjjivanBank />}
              />
              <Route
                path="/city-union-bank/credit-card"
                element={<CityBank />}
              />
              <Route
                path="/south-indian-bank/credit-card"
                element={<SouthIndianBank />}
              />
              <Route path="/dcb-bank/credit-card" element={<DcbBank />} />
              <Route path="/dcb-bank/credit-card" element={<DcbBank />} />
              <Route path="/jk-bank/credit-card" element={<JKBank />} />
              <Route
                path="/karur-vysya-bank/credit-card"
                element={<KvbBank />}
              />
              <Route path="/canara-bank/credit-card" element={<CanaraBank />} />
              <Route path="/union-bank/credit-card" element={<UnionBank />} />
              <Route
                path="/punjab-national-bank/credit-card"
                element={<PnbBank />}
              />
              <Route path="/rbl-bank/credit-card" element={<Rbl />} />
              <Route
                path="/kotak-mahindra-bank/credit-card"
                element={<KotakMahindra />}
              />
              <Route path="/amex_detail" element={<AMEX />} />
              <Route path="/au-bank/credit-card" element={<Au />} />
              <Route path="/axis-bank/credit-card" element={<AXIX />} />
              <Route path="/icici-bank/credit-card" element={<ICICI />} />
              <Route path="/idfc-bank/credit-card" element={<IDFC />} />
              <Route path="/induslnd-bank/credit-card" element={<Indulnd />} />
              <Route path="/sbi-bank/credit-card" element={<SBI />} />
              <Route path="/hdfc-bank/credit-card" element={<HDFC />} />
              <Route
                path="/bank-of-baroda/credit-card"
                element={<BankOfBaroda />}
              />
              <Route path="/citi_detail" element={<Citi />} />
              <Route path="/federal-bank/credit-card" element={<Federal />} />
              <Route path="/hsbc-bank/credit-card" element={<Hsbc />} />
              <Route path="/kotak_detail" element={<Kotak />} />
              <Route path="/american-bank/credit-card" element={<American />} />
              <Route path="/standard-bank/credit-card" element={<Standard />} />
              <Route path="/yes-bank/credit-card" element={<YesBank />} />
              <Route path="/hdfc_learn_more" element={<HdfcLearnMore />} />
              <Route
                path="/credit-card/reward-credit-card"
                element={<RewardCredit />}
              />
              <Route
                path="/credit-card/lifestyle-credit-card"
                element={<LifeStyleCreditCard />}
              />

              <Route
                path="/credit-card/business-credit-card"
                element={<BusinessCreditCard />}
              />

              <Route
                path="/credit-card/travel-credit-card"
                element={<Travel />}
              />
              <Route
                path="/credit-card/best-cashback-credit-card"
                element={<CashBack />}
              />
              <Route
                path="/credit-card/best-premium-credit-card"
                element={<Premium />}
              />
              <Route
                path="/credit-card/best-lifetime-free-credit-cards"
                element={<LifeTimeFee />}
              />
              <Route path="/credit-card/fuel-credit-card" element={<Fuel />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact-us" element={<ContactPage />} />
              <Route path="/credit-card" element={<CreditCardPage />} />

              {/* <Route path='/demat_learn_more' element={<DematLearnMore />} /> */}
              {/* <Route path='/detailofbank' element={<BankDetail />} /> */}
              {/* <Route path='/personal_loan' element={<PersonalLoan />} /> */}

              {/* <Route path='/demat' element={<Demat />} /> */}
              {/* <Route path='/research' element={<ResearchPage />} /> */}

              {/* <Route path='/insurance' element={<InsurancePage />} /> */}
              {/* <Route path='/life-Insurance' element={<LifeInsurance />} />
        <Route path='/health-insurance' element={<HealthInsurance />} />
        <Route path='/car-insurance' element={<CarInsurance />} />
        <Route path='/bike-insurance' element={<BikeInsurance />} /> */}
              {/* <Route path='/term_insurance' element={<TermInsurance />} /> */}
              {/* <Route path='/travel-insurance' element={<TravelInsurance />} /> */}
              {/* <Route path='/blog' element={<BlogPage />} /> */}
              {/* <Route path='/blog_page/:id' element={<BlogPost />} /> */}
              {/* <Route path='/video/:id' element={<VideoDetail />} />
          <Route path='/channel/:id' element={<ChannelDetail />} />
          <Route path='/search/:searchTerm' element={<SearchFeed />} /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <LayoutGTM>
              <FooterComponent />
            </LayoutGTM>
          </LayoutScroll>
        </Layout>
      </ErrorBoundary>
      {/* </Box> */}
    </>
  );
}

export default App;
